webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressLoader_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8def944_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressLoader_vue__ = __webpack_require__(566);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_progressLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8def944_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_progressLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cServerTable_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691a1ce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cServerTable_vue__ = __webpack_require__(745);
function injectStyle (ssrContext) {
  __webpack_require__(581)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cServerTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691a1ce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cServerTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pieOptions = undefined;

var _highcharts = __webpack_require__(340);

var _highcharts2 = _interopRequireDefault(_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pieOptions = exports.pieOptions = {
  chart: {
    type: 'pie',
    plotBackgroundColor: null,
    plotBorderWidth: null,
    height: 300
  },
  title: {
    text: ''
  },
  series: [{
    name: 'data',
    data: []
  }],
  colors: [],
  tooltip: {
    pointFormat: '{series.name}: <b>{point.y}</b>'
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      depth: 10,
      dataLabels: {
        enabled: true,
        format: '<b>{point.name}</b>: {point.y}',
        distance: -30,
        style: {
          color: _highcharts2.default.theme && _highcharts2.default.theme.contrastTextColor || 'black'
        }
      },
      size: '80%'
    }
  },
  noData: {
    attr: 'no Item display',
    position: {
      align: 'center',
      verticalAlign: 'middle',
      x: 0,
      y: 0
    }
  },
  credits: {
    enabled: false
  }
};

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(517);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(518);

var _Login2 = _interopRequireDefault(_Login);

var _Logout = __webpack_require__(527);

var _Logout2 = _interopRequireDefault(_Logout);

var _ForgotPassword = __webpack_require__(530);

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _ResetPassword = __webpack_require__(550);

var _ResetPassword2 = _interopRequireDefault(_ResetPassword);

var _Overview = __webpack_require__(553);

var _Overview2 = _interopRequireDefault(_Overview);

var _ChangePassword = __webpack_require__(555);

var _ChangePassword2 = _interopRequireDefault(_ChangePassword);

var _Index = __webpack_require__(568);

var _Index2 = _interopRequireDefault(_Index);

var _Detail = __webpack_require__(747);

var _Detail2 = _interopRequireDefault(_Detail);

var _Index3 = __webpack_require__(750);

var _Index4 = _interopRequireDefault(_Index3);

var _Form = __webpack_require__(752);

var _Form2 = _interopRequireDefault(_Form);

var _Detail3 = __webpack_require__(754);

var _Detail4 = _interopRequireDefault(_Detail3);

var _Settings = __webpack_require__(758);

var _Settings2 = _interopRequireDefault(_Settings);

var _Index5 = __webpack_require__(760);

var _Index6 = _interopRequireDefault(_Index5);

var _Form3 = __webpack_require__(764);

var _Form4 = _interopRequireDefault(_Form3);

var _Detail5 = __webpack_require__(766);

var _Detail6 = _interopRequireDefault(_Detail5);

var _Index7 = __webpack_require__(768);

var _Index8 = _interopRequireDefault(_Index7);

var _Form5 = __webpack_require__(770);

var _Form6 = _interopRequireDefault(_Form5);

var _Detail7 = __webpack_require__(773);

var _Detail8 = _interopRequireDefault(_Detail7);

var _Index9 = __webpack_require__(775);

var _Index10 = _interopRequireDefault(_Index9);

var _Form7 = __webpack_require__(777);

var _Form8 = _interopRequireDefault(_Form7);

var _Detail9 = __webpack_require__(784);

var _Detail10 = _interopRequireDefault(_Detail9);

var _Full = __webpack_require__(788);

var _Full2 = _interopRequireDefault(_Full);

var _Index11 = __webpack_require__(841);

var _Index12 = _interopRequireDefault(_Index11);

var _Page = __webpack_require__(873);

var _Page2 = _interopRequireDefault(_Page);

var _Page3 = __webpack_require__(875);

var _Page4 = _interopRequireDefault(_Page3);

var _User = __webpack_require__(877);

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/login',
    name: 'Login',
    component: _Login2.default,
    meta: { requiresGuest: true, bodyClass: 'authPage' }
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: _ForgotPassword2.default,
    meta: { requiresGuest: true, bodyClass: 'authPage' }
  }, {
    path: '/reset-password/:id',
    name: 'ResetPassword',
    component: _ResetPassword2.default,
    meta: { requiresGuest: true, bodyClass: 'authPage' }
  }, {
    path: '/',
    redirect: '/dashboard',
    name: 'home',
    component: _Full2.default,
    children: [{
      path: '/dashboard',
      name: 'Dashboard',
      component: _Index12.default,
      meta: { requiresAuth: true }
    }, {
      path: 'profile',
      name: 'User Profile',
      component: _Overview2.default,
      children: [{
        path: 'password',
        name: 'Change Password',
        component: _ChangePassword2.default
      }]
    }, {
      path: 'tickets',
      name: 'Tickets',
      component: _Index4.default,
      children: [{
        path: 'create',
        name: 'Add New Ticket',
        component: _Form2.default
      }, {
        path: ':id/edit',
        name: 'Edit Ticket',
        component: _Form2.default
      }, {
        path: ':id',
        name: 'Ticket Details',
        component: _Detail4.default
      }]
    }, {
      path: 'visited-sites',
      name: 'Visited Sites',
      component: _Index2.default,
      children: [{
        path: ':id',
        name: 'Visited Site Details',
        component: _Detail2.default
      }]
    }, {
      path: 'settings',
      name: 'Settings',
      component: _Settings2.default,
      children: [{
        path: 'user',
        name: 'User',
        component: _User2.default,
        redirect: '/settings/user/contractors',
        children: [{
          path: 'admin',
          name: 'Administrators',
          component: _Index6.default,
          children: [{
            path: 'create',
            name: 'Add New Administrator',
            component: _Form4.default
          }, {
            path: ':id/edit',
            name: 'Edit Administrator',
            component: _Form4.default
          }, {
            path: ':id',
            name: 'Administrator Details',
            component: _Detail6.default
          }]
        }, {
          path: 'contractors',
          name: 'Contractors',
          component: _Index8.default,
          children: [{
            path: 'create',
            name: 'Add New Contractor',
            component: _Form6.default
          }, {
            path: ':id/edit',
            name: 'Edit Contractor',
            component: _Form6.default
          }, {
            path: ':id',
            name: 'Contractor Details',
            component: _Detail8.default
          }]
        }]
      }, {
        path: 'sites',
        name: 'Sites',
        component: _Index10.default,
        children: [{
          path: 'create',
          name: 'Add New Site',
          component: _Form8.default
        }, {
          path: ':id/edit',
          name: 'Edit Site',
          component: _Form8.default
        }, {
          path: ':id',
          name: 'Site Details',
          component: _Detail10.default
        }]
      }]
    }],
    meta: { requiresAuth: true }
  }, {
    path: '/logout',
    name: 'Logout',
    component: _Logout2.default,
    meta: { requiresAuth: true }
  }, {
    path: '*',
    name: 'others',
    redirect: '/404',
    component: _Full2.default,
    children: [{
      path: '/404',
      name: 'Page Not Found',
      component: _Page2.default
    }, {
      path: '/500',
      name: 'Page Get Internal Error',
      component: _Page4.default
    }]
  }]
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      errorMsg: null,
      isLoading: false,
      user: {
        username: {
          required: true,
          rule: 'any',
          value: null,
          error: null
        },
        password: {
          required: true,
          rule: 'any',
          value: null,
          error: null
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      this.errorMsg = null;
      var hasError = false;
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length; i++) {
        if (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].required && (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === null || this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === '')) {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'This field is required.';
          hasError = true;
        } else if ((this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value !== null || this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value !== '') && this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].rule === 'integer' && !parseInt(this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value, 10)) {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'This field must be integer date.';
          hasError = true;
        } else {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = null;
        }
      }
      if (hasError) {
        this.isLoading = false;
        return false;
      }
      this.$store.dispatch('login', {
        username: this.user.username.value,
        password: this.user.password.value
      }).then(function (response) {
        if (_this.$route.query.redirect !== undefined) {
          _this.$router.push(_this.$route.query.redirect);
        } else {
          _this.$router.push('/');
        }
      }).catch(function (error) {
        _this.isLoading = false;
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.errorMsg = errMsg;
        });
      });
    }
  }
});

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('logout').then(function (response) {
      return _this.$router.push('/login');
    });
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ForgotPassword',
  data: function data() {
    return {
      errorMsg: null,
      successMsg: null,
      isLoading: false,
      user: {
        emailAddress: {
          rule: 'email',
          value: null,
          error: null
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.isLoading = true;
      this.errorMsg = null;
      var hasError = false;
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length; i++) {
        if (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === null || this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === '') {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'This field is required.';
          hasError = true;
        } else if (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].rule === 'email' && /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value) === false) {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'This field must be email.';
          hasError = true;
        } else {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = null;
        }
      }
      if (hasError) {
        this.isLoading = false;
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.AppConfig.apiUrl + 'resetpassword/email', {
        emailAddress: this.user.emailAddress.value,
        account: window.AppConfig.subDomain
      }).then(function (response) {
        _this.isLoading = false;
        _this.user.emailAddress.value = null;
        _this.successMsg = 'Password reset complete, Please check your email inbox or spam.';
      }).catch(function (error) {
        _this.isLoading = false;
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.errorMsg = errMsg;
        });
      });
    }
  }
});

/***/ }),
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMsg: null,
      successMsg: null,
      isLoading: false,
      resetPasswordKey: null,
      user: {
        password: {
          rule: 'any',
          value: null,
          error: null
        },
        passwordConfirmation: {
          rule: 'confirmation',
          value: null,
          error: null
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var _this = this;

      this.isLoading = true;
      this.successMsg = null;
      this.errorMsg = null;
      var hasError = false;
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length; i++) {
        if (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === null || this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].value === '') {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'This field is required.';
          hasError = true;
        } else if (this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].rule === 'confirmation' && this.user.password.value !== this.user.passwordConfirmation.value) {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = 'Password and password confirmation do not match.';
          hasError = true;
        } else {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = null;
        }
      }
      if (hasError) {
        this.isLoading = false;
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(window.AppConfig.apiUrl + 'resetpassword/newpassword', {
        resetPasswordKey: this.$route.params.id,
        newPassword: this.user.password.value,
        confirmNewPassword: this.user.passwordConfirmation.value
      }).then(function (response) {
        _this.isLoading = false;
        _this.user.password.value = null;
        _this.user.passwordConfirmation.value = null;
        _this.successMsg = 'Password has been changed.';
      }).catch(function (error) {
        _this.isLoading = false;
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.errorMsg = errMsg;
        });
      });
    }
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileOverview'
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ChangePassword',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrl: window.AppConfig.apiUrl + 'change-password',
      showLoader: false,
      errorMsg: null,
      account: {
        currentPassword: {
          rule: 'required editable',
          value: null,
          error: null
        },
        newPassword: {
          rule: 'required editable',
          value: null,
          error: null
        },
        confirmPassword: {
          rule: 'required editable',
          value: null,
          error: null
        }
      }
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      this.errorMsg = null;
      var hasError = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.account);

      for (var i = 0; i < obj.length; i++) {
        var rule = this.account[obj[i]].rule;
        if ((rule.indexOf('required') !== -1 || this.isEditMode && rule.indexOf('editable') !== -1 && rule.indexOf('required') !== -1) && (this.account[obj[i]].value === null || this.account[obj[i]].value === '' || this.account[obj[i]].value.HH === null)) {
          this.account[obj[i]].error = 'This field is required';
          hasError = true;
        } else if (obj[i] === 'confirmPassword' && this.account.newPassword.value !== this.account.confirmPassword.value) {
          this.account[obj[i]].error = 'New Password & Confirm Password does not match';
          hasError = true;
        } else {
          this.account[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.account)[i]].error = null;
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar();
        this.$alertify.error('Failed! Please complete the message and submit again.');
        return false;
      }

      var formData = {
        'currentPassword': null,
        'newPassword': null,
        'confirmPassword': null
      };
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.account).length; _i++) {
        var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.account)[_i];
        formData[key] = this.account[key].value;
      }
      var self = this;
      self.$refs.progress.activateProgressBar();

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.apiUrl, formData).then(function (response) {
        self.$refs.progress.deactivateProgressBar();
        self.setEmptyForm();
        self.$alertify.success('Password Has Been Changed!');
        window.location.href = document.URL.replace('/profile/password', '/profile');
      }).catch(function (error) {
        self.doCollectErrMessage(error);
      });
    },
    setEmptyForm: function setEmptyForm() {
      this.account.currentPassword.value = null;
      this.account.newPassword.value = null;
      this.account.confirmPassword.value = null;
    },
    doCollectErrMessage: function doCollectErrMessage(error) {
      var _this = this;

      this.$refs.progress.deactivateProgressBar();
      this.$alertify.error('Failed! Please complete the message and submit again.');
      this.$store.dispatch('errorMessage', error).then(function (errMsg) {
        _this.errorMsg = errMsg;
      });
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'progress-loader',
  props: {
    customClass: '',
    customStyle: ''
  },
  data: function data() {
    return {
      counter: 45,
      max: 100,
      showLoader: false
    };
  },

  methods: {
    activateProgressBar: function activateProgressBar() {
      this.counter = Math.random() * this.max;
      this.showLoader = true;

      var objFooter = document.getElementsByClassName('card-footer');
      if (objFooter.length > 0) {
        var arrBtn = objFooter[0].getElementsByClassName('btn');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arrBtn), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var a = _step.value;

            a.disabled = true;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    deactivateProgressBar: function deactivateProgressBar() {
      this.counter = this.max;
      this.showLoader = false;
      var objFooter = document.getElementsByClassName('card-footer');
      if (objFooter.length > 0) {
        var arrBtn = objFooter[0].getElementsByClassName('btn');
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arrBtn), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var a = _step2.value;

            a.disabled = false;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    },
    getClass: function getClass() {
      return 'animated ' + (this.showLoader ? '' : 'fade') + ' ' + this.customClass;
    }
  }
});

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_cServerTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'facilityBookingIndex',
  components: {
    cServerTable: __WEBPACK_IMPORTED_MODULE_2__views_components_cServerTable__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker___default.a
  },
  data: function data() {
    var config = __WEBPACK_IMPORTED_MODULE_2__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['startTime', 'endTime', 'site', 'visitedBy', 'description', 'actionButtons3'],
      options: {
        headings: {
          startTime: 'Start Time',
          endTime: 'End Time',
          visitedBy: 'Visited By',
          actionButtons3: ''
        },
        sortable: ['startTime', 'endTime'],
        uniqueKey: 'uuid',
        params: {
          start_time: this.$route.query.start_time,
          end_time: this.$route.query.end_time,
          facility_booking_status_uuid: this.$route.query.facility_booking_status_uuid,
          site_uuid: this.$route.query.site_uuid
        },
        templates: {
          startTime: function startTime(h, row) {
            return row.startTime !== null ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(row.startTime).format(window.AppConfig.dateFormat) : '-';
          },
          endTime: function endTime(h, row) {
            return row.endTime !== null ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(row.endTime).format(window.AppConfig.dateFormat) : '-';
          },
          site: function site(h, row) {
            return row.site.name;
          },
          task: function task(h, row) {
            return row.task !== null ? row.task.name : '-';
          }
        }
      }
    }, 'siteVisit');

    return {
      apiUrl: window.AppConfig.apiUrl + 'site-visit',
      apiUrlFacility: window.AppConfig.apiUrl + 'site?limit=10000000000000000000000',
      apiUrlFacilityBookingStatus: window.AppConfig.apiUrl + 'facility-booking-status',

      columns: config.columns,
      options: config.options,

      filterBy: {
        DateTime: window.setDefaultNull(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.$route.query.start_time)) === null ? null : [window.setDefaultNull(this.$route.query.start_time), window.setDefaultNull(this.$route.query.end_time)],
        facilityBookingStatusList: [],
        facility_booking_status_uuid: window.setDefaultNull(this.$route.query.facility_booking_status_uuid),
        facilityList: [],
        site_uuid: window.setDefaultNull(this.$route.query.site_uuid),
        DateTimeNotAfter: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
      }
    };
  },
  mounted: function mounted() {
    this.initDropdownOptions_Facility();
  },

  methods: {
    initDropdownOptions_Facility: function initDropdownOptions_Facility() {
      var _this = this;

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrlFacility).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.site;
          datas.sort(function (a, b) {
            return parseInt(a.order) - parseInt(b.order);
          });
          for (var i = 0; i < response.data.total_items; i++) {
            _this.filterBy.facilityList.push({ text: datas[i].name, value: datas[i].uuid });
          }
        }
      }).catch(function (error) {
        self.$store.dispatch('errorMessage', error).then(function (errMsg) {
          self.$alertify.error(errMsg);
        });
      });
    },
    initDropdownOptions_FacilityBookingStatus: function initDropdownOptions_FacilityBookingStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrlFacilityBookingStatus).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.bookingStatus;
          datas.sort(function (a, b) {
            return parseInt(a.order) - parseInt(b.order);
          });
          for (var i = 0; i < response.data.total_items; i++) {
            _this2.filterBy.facilityBookingStatusList.push({ text: datas[i].name, value: datas[i].uuid });
          }
        }
      }).catch(function (error) {
        var _this3 = this;

        this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this3.$alertify.error(errMsg);
        });
      });
    },
    setColorStatus: function setColorStatus(value) {
      switch (value) {
        case 'Requested':
          return 'primary';
        case 'Rejected':
          return 'danger';
        case 'Approved':
          return 'success';
        case 'Check In':
          return 'info';
        case 'Check Out':
          return 'dark';
        case 'Cancelled':
          return 'warning';
        default:
          return 'light';
      }
    },
    doBookingApproval: function doBookingApproval(row, status, note) {
      var _this4 = this;

      if (status === 'Rejected' && note === '') {
        this.$alertify.error('Can\'t Update. Reject Note is Required.');
        return false;
      } else {
        var listStatus = this.filterBy.facilityBookingStatusList;
        var uuidStatus = null;
        for (var i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value;
        }
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.apiUrl + '/' + row.uuid, {
          facilityBookingStatus: uuidStatus,
          bookingNote: note
        }).then(function (response) {
          _this4.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>');
          row.facilityBookingStatus = status;
        }).catch(function (error) {
          _this4.$store.dispatch('errorMessage', error).then(function (errMsg) {
            _this4.$alertify.error(errMsg);
          });
        });
      }
    },
    doConfirmRejecting: function doConfirmRejecting(row) {
      var _this5 = this;

      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '', function (evt, value) {
        return _this5.doBookingApproval(row, 'Rejected', value);
      });
    },
    doFilter: function doFilter() {
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.options.params.start_time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filterBy.DateTime[0]).format('YYYY-MM-DD');
        this.options.params.end_time = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.filterBy.DateTime[1]).format('YYYY-MM-DD');
      } else {
        this.options.params.start_time = null;
        this.options.params.end_time = null;
      }
      this.options.params.site_uuid = window.setDefaultNull(this.filterBy.site_uuid);
      this.options.params.facility_booking_status_uuid = window.setDefaultNull(this.filterBy.facility_booking_status_uuid);
      this.$refs.dataTable.options.params = this.options.params;
      this.$refs.dataTable.setTableDatas();
    }
  }
});

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tables_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_components_progressLoader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_tables_2__["ServerTable"]);

var responseData = null;

var initalConfig = function initalConfig(adapterName) {
  return {
    filterable: false,

    footerHeadings: false,

    itemActions: [],

    params: {
      ascending: 0,
      order: 'createdAt'
    },
    perPage: 10,
    perPageValues: [],

    skin: 'table table-striped',
    sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
    sortable: [],

    requestFunction: function requestFunction(data) {
      var customParams = window.setUrlParams(data);
      var self = this;
      this.$router.replace({ query: customParams });
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this._props.url, { params: customParams }).then(function (response) {
        if (response !== undefined) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).length) {
            responseData = response.data;
            return response;
          } else {
            return undefined;
          }
        }
      }).catch(function (error) {
        self.$store.dispatch('errorMessage', error).then(function (errMsg) {
          self.$alertify.error(errMsg);
        });
      });
    },
    responseAdapter: function responseAdapter(resp) {
      return {
        data: resp === undefined || resp.length === 0 ? [] : resp.data._embedded[adapterName],
        count: resp === undefined || resp.length === 0 ? 0 : resp.data.total_items
      };
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cServerTable',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_4__views_components_progressLoader__["a" /* default */]
  },
  props: {
    url: '',
    urlRemove: '',
    columns: null,
    options: null,
    method_1: null,
    method_2: null,
    method_3: null,
    method_4: null,
    method_result: null
  },
  data: function data() {
    return {
      ApprovalRejected: [],
      apiUrlBillingStatus: window.AppConfig.apiUrl + 'billing-status',
      apiUrlUpdateBillingStatus: window.AppConfig.apiUrl + 'billing',
      paymentIds: [],
      makePaymentDialog: {
        showLoader: false,
        note: '',
        paymentMethod: 'Cash'
      },
      printInvoice: false,
      paidBillings: []
    };
  },
  created: function created() {
    var url = new URL(window.location.href.replace('/#/', '/'));
    this.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1;
  },
  beforeMount: function beforeMount() {
    var url = new URL(window.location.href.replace('/#/', '/'));
    this.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1;
  },
  mounted: function mounted() {
    this.doAutoRefresh();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.ref);
  },

  methods: {
    setTableDatas: function setTableDatas() {
      this.$refs.dataTable.refresh();
    },
    setLimit: function setLimit(value) {
      this.$refs.dataTable.setLimit(value);
    },
    setTableConfig: function setTableConfig(config, adapterName) {
      var opt = {};
      opt.columns = config.columns;
      opt.options = initalConfig(adapterName);
      var url = new URL(window.location.href.replace('/#/', '/'));
      opt.options.initialPage = url.searchParams.get('page') !== null ? url.searchParams.get('page') : 1;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(config.options).map(function (index) {
        if (index === 'params') {
          opt.options['params'] = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(config.options[index]).map(function (param) {
            opt.options.params[param] = window.setDefaultNull(config.options.params[param]);
          });
        } else {
          opt.options[index] = config.options[index];
        }
      });
      return opt;
    },
    getUrlDetail: function getUrlDetail(uuid) {
      var tmp = this.$route.matched[this.$route.matched.length - 1].path;
      if (tmp === '' || tmp.slice(-1) !== '/') tmp += '/';
      return '#' + tmp + uuid;
    },
    getOverTime: function getOverTime(dueDate) {
      return 'Since ' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(dueDate).fromNow();
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this = this;

      this.ref = setInterval(function () {
        _this.setTableDatas();
      }, window.AppConfig.IntervalRefreshData);
    },
    doOpenRowDetail: function doOpenRowDetail(id) {
      this.$refs.dataTable.toggleChildRow(id);
    },
    doRemove: function doRemove(uuid) {
      var _this2 = this;

      this.$alertify.confirm('Are you sure want to remove it ?', function () {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete((_this2.urlRemove != undefined ? _this2.urlRemove : _this2.url) + '/' + uuid).then(function (response) {
          _this2.$alertify.success('Successfully deleted.');
          _this2.setTableDatas();
        }).catch(function (error) {
          _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
            _this2.$alertify.error(errMsg);
          });
        });
      }, null);
    },
    onTableLoading: function onTableLoading() {
      this.$refs.progress.activateProgressBar();
      this.$store.dispatch('setIsOffline', false);
    },
    onTableLoaded: function onTableLoaded() {
      this.$refs.progress.deactivateProgressBar();
      if (this.method_result !== undefined) {
        this.method_result(responseData);
      }
    },
    onPagination: function onPagination() {},
    addIdMultiPayment: function addIdMultiPayment(id) {
      var index = this.paymentIds.indexOf(id);
      if (index > -1) {
        this.paymentIds.splice(index, 1);
      } else {
        this.paymentIds.push(id);
      }
    },
    makeMultiplePayment: function makeMultiplePayment() {
      this.$refs.makePayment.show();
      this.makePaymentDialog.showLoader = false;
      this.makePaymentDialog.hasError = false;
      this.makePaymentDialog.note = '';
      this.makePaymentDialog.paymentMethod = 'Cash';
    },
    doMultiplePayment: function doMultiplePayment() {
      var _this3 = this;

      this.makePaymentDialog.showLoader = true;
      if (this.makePaymentDialog.note === '') {
        this.$alertify.error('Can\'t Update. Reject Note is Required.');
        this.makePaymentDialog.showLoader = false;
      } else {
        var billingUuid = [];
        for (var i = 0; i < this.paymentIds.length; i++) {
          billingUuid.push({
            uuid: this.paymentIds[i]
          });
        }
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.apiUrlUpdateBillingStatus, {
          billingUuid: billingUuid,
          note: this.makePaymentDialog.note,
          method: this.makePaymentDialog.paymentMethod }).then(function (response) {
          _this3.paymentIds = [];
          _this3.$refs.makePayment.hide();
          _this3.$refs.dataTable.refresh();
          _this3.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + (_this3.makePaymentDialog.paymentMethod === 'Cheque' || _this3.makePaymentDialog.paymentMethod === 'Credit Card' ? 'Pending' : status) + '</b>');
          _this3.paidBillings = response.data;
          _this3.printInvoice = true;
        }).catch(function (error) {
          window.consoleLog('error');
          _this3.$refs.makePayment.hide();
          _this3.$store.dispatch('errorMessage', error).then(function (errMsg) {
            _this3.$alertify.error(errMsg);
          });
        });
      }
    },
    toggleCheckbox: function toggleCheckbox(className, arrayName) {
      var a = document.querySelectorAll('.make-payment-now .custom-control-input');
      if (this[arrayName].length) {
        this[arrayName] = [];
        for (var i = 0; i < a.length; i++) {
          a[i].checked = false;
        }
      } else {
        this[arrayName] = [];
        for (var _i = 0; _i < a.length; _i++) {
          a[_i].checked = true;
          this.addIdMultiPayment(a[_i].value);
        }
      }
    }
  }
});

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'facilityCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a
  },
  data: function data() {
    return {
      apiUrl: window.AppConfig.apiUrl + 'site-visit',
      apiUrlFacilityBookingStatus: window.AppConfig.apiUrl + 'facility-booking-status',
      apiUrlGetFacilityBookingStatusLog: window.AppConfig.apiUrl + 'facility-booking-status-log?ascending=1&facility_booking_uuid=',
      facility: {
        uuid: null,
        startTime: null,
        endTime: null,
        description: null,
        task: null,
        taskName: null,
        site: null,
        visitedBy: null
      },
      facilityBookingStatusLog: [],
      photos: []
    };
  },
  mounted: function mounted() {
    this.getDetailInfo();
    this.getPhotos();
  },

  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.getDetailInfo();
    }
  },
  methods: {
    getDetailInfo: function getDetailInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrl + '/' + this.$route.params.id).then(function (response) {
        var data = response.data;
        window.setDetailValue(_this.facility, response.data);

        _this.facility.startTime = data.startTime === null ? '-' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(response.data.startTime).format(window.AppConfig.dateFormat);
        _this.facility.endTime = data.endTime === null ? '-' : __WEBPACK_IMPORTED_MODULE_1_moment___default()(response.data.endTime).format(window.AppConfig.dateFormat);
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    getDetailTask: function getDetailTask(taskUuid) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.AppConfig.apiUrl + 'task' + '/' + taskUuid).then(function (response) {
        var data = response.data;
        _this2.facility.taskName = data.name;
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    getPhotos: function getPhotos() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.AppConfig.apiUrl + 'site-visit-photo?site_visit_uuid=' + this.$route.params.id).then(function (response) {
        _this3.photos = response.data._embedded.siteVisitPhoto;
      }).catch(function (error) {
        _this3.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this3.$alertify.error(errMsg);
        });
      });
    },
    getStatusColor: function getStatusColor(value) {
      switch (value) {
        case 'Requested':
          return 'primary';
        case 'Rejected':
          return 'danger';
        case 'Approved':
          return 'success';
        case 'Check In':
          return 'info';
        case 'Check Out':
          return 'dark';
        case 'Cancelled':
          return 'warning';
        default:
          return 'light';
      }
    },
    doBookingApproval: function doBookingApproval(row, status, note) {
      var _this4 = this;

      var self = this;
      if (status === 'Rejected' && note === '') {
        self.$alertify.error('Can\'t Update. Reject Note is Required.');
        return false;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(self.apiUrlFacilityBookingStatus).then(function (response) {
          if (response !== undefined) {
            var uuidStatus = null;
            var datas = response.data._embedded.bookingStatus;
            for (var i = 0; i < response.data.total_items; i++) {
              if (datas[i].name === status) {
                uuidStatus = datas[i].uuid;
              }
            }
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(self.apiUrl + '/' + row.uuid, {
              facilityBookingStatus: uuidStatus,
              bookingNote: note
            }).then(function (response) {
              self.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>');
              row.facilityBookingStatus = status;
              _this4.getFacilityBookingStatusLog();
            }).catch(function (error) {
              self.$store.dispatch('errorMessage', error).then(function (errMsg) {
                self.$alertify.error(errMsg);
              });
            });
          }
        }).catch(function (error) {
          self.$store.dispatch('errorMessage', error).then(function (errMsg) {
            self.$alertify.error(errMsg);
          });
        });
      }
    },
    doConfirmRejecting: function doConfirmRejecting(row) {
      var _this5 = this;

      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '', function (evt, value) {
        return _this5.doBookingApproval(row, 'Rejected', value);
      });
    },
    isRequested: function isRequested() {
      return this.facility.facilityBookingStatus === 'Requested';
    },
    goBack: function goBack() {
      window.goBack(this);
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'complaintIndex',
  components: {
    cServerTable: __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a
  },
  data: function data() {
    var config = __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['name', 'createdBy', 'assigned', 'taskStatus', 'createdAt', 'actionButtons3'],
      options: {
        headings: {
          name: 'Name',
          createdBy: 'Created By',
          requestedBy: 'Requested By',
          assigned: 'Assigned',
          assignedRole: 'Role',
          taskCategory: 'Category',
          taskStatus: 'Status',
          createdAt: 'Created Time',
          actionButtons3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          assignedRole: this.$route.query.role,
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          task_status_uuid: this.$route.query.task_status_uuid,
          task_category_uuid: 'a2c92744-ecd5-4276-88e9-70a8ac41154d'
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.createdAt !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          },
          createdBy: function createdBy(h, row) {
            return row.createdBy.name;
          },
          requestedBy: function requestedBy(h, row) {
            return row.requestedBy.name;
          },
          assigned: function assigned(h, row) {
            return row.assigned.name;
          },
          assignedRole: function assignedRole(h, row) {
            return row.assigned.role !== null ? row.assigned.role.charAt(0).toUpperCase() + row.assigned.role.slice(1) : '-';
          }
        }
      }
    }, 'task');

    return {
      apiUrl: window.AppConfig.apiUrl + 'task?descending=1',
      apiUrlTaskStatus: window.AppConfig.apiUrl + 'task-status',
      apiUrlTaskCategory: window.AppConfig.apiUrl + 'task-category',

      columns: config.columns,
      options: config.options,

      filterBy: {
        DateTime: window.setDefaultNull(this.$route.query.start_date) === null ? null : [window.setDefaultNull(this.$route.query.start_date), window.setDefaultNull(this.$route.query.end_date)],
        taskStatusList: [],
        taskCategoryList: [],
        assignedRole: this.$route.query.role,
        task_status_uuid: window.setDefaultNull(this.$route.query.task_status_uuid),
        task_category_uuid: 'a2c92744-ecd5-4276-88e9-70a8ac41154d',
        DateTimeNotAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD')
      }
    };
  },
  mounted: function mounted() {
    this.initDropdownOptions_TaskStatus();
  },

  methods: {
    initDropdownOptions_TaskStatus: function initDropdownOptions_TaskStatus() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlTaskStatus).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.taskStatus;
          datas.sort(function (a, b) {
            return parseInt(a.order) - parseInt(b.order);
          });
          for (var i = 0; i < response.data.total_items; i++) {
            self.filterBy.taskStatusList.push({ text: datas[i].name, value: datas[i].uuid });
          }
        }
      }).catch(function (error) {
        self.$store.dispatch('errorMessage', error).then(function (errMsg) {
          self.$alertify.error(errMsg);
        });
      });
    },
    initDropdownOptions_TaskCategory: function initDropdownOptions_TaskCategory() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlTaskCategory).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.taskCategory;
          datas.sort(function (a, b) {
            return parseInt(a.order) - parseInt(b.order);
          });
          for (var i = 0; i < response.data.total_items; i++) {
            self.filterBy.taskCategoryList.push({ text: datas[i].name, value: datas[i].uuid });
          }
        }
      }).catch(function (error) {
        self.$store.dispatch('errorMessage', error).then(function (errMsg) {
          self.$alertify.error(errMsg);
        });
      });
    },
    getStatusColor: function getStatusColor(status) {
      switch (status) {
        case 'Assigned':
          return 'warning';
        case 'Accepted':
          return 'info';
        case 'In Progress':
          return 'primary';
        case 'Completed':
          return 'success';
        default:
          return 'danger';
      }
    },
    doFilter: function doFilter() {
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.options.params.start_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.filterBy.DateTime[0]).format('YYYY-MM-DD');
        this.options.params.end_date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.filterBy.DateTime[1]).format('YYYY-MM-DD');
      } else {
        this.options.params.start_date = null;
        this.options.params.end_date = null;
      }
      this.options.params.assignedRole = this.filterBy.assignedRole;
      this.options.params.task_status_uuid = window.setDefaultNull(this.filterBy.task_status_uuid);
      this.options.params.task_category_uuid = 'a2c92744-ecd5-4276-88e9-70a8ac41154d';
      this.$refs.dataTable.options.params = this.options.params;
      this.$refs.dataTable.setTableDatas();
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'taskCreate',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'task',
      apiUrlGetDetail: window.AppConfig.apiUrl + 'task',

      showLoader: false,
      errorMsg: null,
      sites: [],
      tenants: [],
      task: {
        uuid: {
          rule: 'editable',
          value: this.$route.params.id
        },
        name: {
          rule: 'required editable',
          value: null,
          error: null
        },
        taskCategory: {
          rule: 'editable',
          value: null,
          error: null
        },
        site: {
          rule: 'required editable',
          tempValue: null,
          value: null,
          error: null
        },
        requestedBy: {
          rule: 'editable',
          value: null,
          error: null
        },
        assigned: {
          rule: 'required editable',
          tempValue: null,
          value: null,
          error: null
        },
        note: {
          rule: 'required editable',
          value: null,
          error: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.setEmptyForm();
    this.getSites();
    this.getTenants();
    if (this.isEditMode) {
      this.getDetailInfo();
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      this.task.assigned.value = null;
      if (this.task.assigned.tempValue !== null) {
        this.task.assigned.value = this.task.assigned.tempValue.uuid;
      }
      this.task.site.value = null;
      if (this.task.site.tempValue !== null) {
        this.task.site.value = this.task.site.tempValue.uuid;
      }

      this.errorMsg = null;
      var hasError = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.task);

      for (var i = 0; i < obj.length; i++) {
        var rule = this.task[obj[i]].rule;
        if ((rule.indexOf('required') !== -1 || this.isEditMode && rule.indexOf('editable') !== -1 && rule.indexOf('required') !== -1) && (this.task[obj[i]].value === null || this.task[obj[i]].value === '' || this.task[obj[i]].value.HH === null)) {
          this.task[obj[i]].error = 'This field is required';
          hasError = true;
        } else {
          this.task[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.task)[i]].error = null;
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar();
        this.$alertify.error('Failed! Please complete the message and submit again.');
        return false;
      }

      var formData = new FormData();
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.task).length; _i++) {
        var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.task)[_i];
        if (this.task[key].value !== null && key !== 'uuid') {
          if (key.indexOf('Time') >= 0) {
            formData.append(key, this.task[key].value.HH + ':' + this.task[key].value.mm);
          } else if (key.indexOf('icon') >= 0) {
            if (typeof this.task[key].value !== 'string') {
              formData.append(key, this.task[key].value);
            }
          } else {
            formData.append(key, this.task[key].value);
          }
        }
      }
      var self = this;
      self.$refs.progress.activateProgressBar();

      if (!this.isEditMode) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.apiUrl, formData).then(function (response) {
          self.$refs.progress.deactivateProgressBar();
          self.setEmptyForm();
          window.setTimeout(function () {
            self.$alertify.success('Ticket has been added!');
          }, 2000);
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
        }).catch(function (error) {
          self.doCollectErrMessage(error);
        });
      } else {
        self.$refs.progress.deactivateProgressBar();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.apiUrl + '/' + this.task.uuid.value, formData).then(function (response) {
          window.setTimeout(function () {
            self.$alertify.success('Ticket has been updated!');
          }, 2000);
          window.location.href = document.URL.replace('/edit', '');
        }).catch(function (error) {
          self.doCollectErrMessage(error);
        });
      }
    },
    getTenants: function getTenants() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(window.AppConfig.apiUrl + 'profile?role=contractor').then(function (response) {
        _this.tenants = [];
        response.data._embedded.profile.forEach(function (profile) {
          _this.tenants.push({
            uuid: profile.uuid,
            name: profile.firstName + (profile.lastName !== null ? ' ' + profile.lastName : '')
          });
        });
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    getSites: function getSites() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(window.AppConfig.apiUrl + 'site').then(function (response) {
        _this2.sites = response.data._embedded.site;
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    getDetailInfo: function getDetailInfo() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        _this3.task.uuid.value = response.data.uuid;
        _this3.task.name.value = response.data.name;
        if (response.data.site !== null) {
          _this3.task.site.value = response.data.site.uuid;
          _this3.task.site.tempValue = response.data.site;
        }
        _this3.task.requestedBy.value = response.data.requestedBy.uuid;
        if (response.data.assigned !== null) {
          _this3.task.assigned.value = response.data.assigned.uuid;
          _this3.task.assigned.tempValue = response.data.assigned;
        }
        _this3.task.note.value = response.data.note;
      }).catch(function (error) {
        _this3.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this3.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    setEmptyForm: function setEmptyForm() {
      this.task.uuid.value = null;
      this.task.uuid.name = null;
      this.task.taskCategory.value = 'a2c92744-ecd5-4276-88e9-70a8ac41154d';
      this.task.site.value = null;
      this.task.site.tempValue = null;
      this.task.requestedBy.value = this.$store.getters.accountData.uuid;
      this.task.assigned.value = null;
      this.task.assigned.tempValue = null;
      this.task.note.value = null;
    },
    doCollectErrMessage: function doCollectErrMessage(error) {
      var _this4 = this;

      this.$alertify.error('Failed! Please complete the message and submit again.');
      this.$store.dispatch('errorMessage', error).then(function (errMsg) {
        _this4.errorMsg = errMsg;
      });
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_progressLoader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_viewer__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(17);








__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_v_viewer___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'taskCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a,
    progressLoader: __WEBPACK_IMPORTED_MODULE_1__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'task',
      apiUrlTaskNote: window.AppConfig.apiUrl + 'task-note?task_uuid=',
      apiUrlTaskPhoto: window.AppConfig.apiUrl + 'task-photo?task_uuid=',
      apiUrlStatus: window.AppConfig.apiUrl + 'task-status-log?ascending=1',
      task: {
        uuid: null,
        assigned: {
          value: []
        },
        site: null,

        createdAt: null,
        createdBy: {
          value: []
        },
        name: null,
        request: null,
        requestedBy: {
          value: []
        },
        taskCategory: null,
        taskStatus: null,
        updatedAt: null
      },
      taskNote: [],
      taskPhoto: [],
      taskStatusLog: [],
      sites: []
    };
  },
  mounted: function mounted() {
    this.getDetailInfo();
    this.getVisisted();
  },

  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.getDetailInfo();
    }
  },
  methods: {
    getVisisted: function getVisisted() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.AppConfig.apiUrl + 'site-visit?ascending=0&order=startTime&task_uuid=' + this.$route.params.id).then(function (response) {
        response.data._embedded.siteVisit.forEach(function (siteVisit) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.AppConfig.apiUrl + 'site-visit-photo?site_visit_uuid=' + siteVisit.uuid).then(function (response) {
            _this.sites.push({
              uuid: siteVisit.uuid,
              startTime: siteVisit.startTime,
              endTime: siteVisit.endTime,
              site: siteVisit.site,
              description: siteVisit.description,
              photos: response.data._embedded.siteVisitPhoto
            });
          }).catch(function (error) {
            _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
              _this.$alertify.error(errMsg);
            });
          });
        });
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    getPhotos: function getPhotos(uuid) {},
    initDropdownOptions_TaskStatus: function initDropdownOptions_TaskStatus() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlStatus + '&task_uuid=' + this.$route.params.id).then(function (response) {
        if (response !== undefined) {
          _this2.taskStatusLog = response.data._embedded.taskStatusLog;
          for (var i = 0; i < _this2.taskStatusLog.length; i++) {
            _this2.taskStatusLog[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this2.taskStatusLog[i]['createdAt']).format(window.AppConfig.dateFormat);
            _this2.taskStatusLog[i]['updatedAt'] = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this2.taskStatusLog[i]['updatedAt']).format(window.AppConfig.dateFormat);
          }
        }
      }).catch(function (error) {
        var _this3 = this;

        this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this3.$alertify.error(errMsg);
        });
      });
    },
    getDetailInfo: function getDetailInfo() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        window.setDetailValue(_this4.task, response.data);
      }).catch(function (error) {
        _this4.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this4.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    getTaskNote: function getTaskNote() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlTaskNote + this.$route.params.id).then(function (response) {
        _this5.taskNote = response.data._embedded.taskNote;
        for (var i = 0; i < _this5.taskNote.length; i++) {
          _this5.taskNote[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this5.taskNote[i]['createdAt']).format(window.AppConfig.dateFormat);
        }
      }).catch(function (error) {
        _this5.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this5.$alertify.error(errMsg);
        });
      });
    },
    getTaskPhoto: function getTaskPhoto() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlTaskPhoto + this.$route.params.id).then(function (response) {
        _this6.taskPhoto = response.data._embedded.taskPhoto;
        for (var i = 0; i < _this6.taskPhoto.length; i++) {
          _this6.taskPhoto[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_this6.taskPhoto[i]['createdAt']).format(window.AppConfig.dateFormat);
        }
      }).catch(function (error) {
        _this6.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this6.$alertify.error(errMsg);
        });
      });
    },
    getStatusColor: function getStatusColor(status) {
      switch (status) {
        case 'Assigned':
          return 'warning';
        case 'Accepted':
          return 'info';
        case 'In Progress':
          return 'primary';
        case 'Completed':
          return 'success';
        default:
          return 'danger';
      }
    },
    setEmptyForm: function setEmptyForm() {
      this.comment.response.value = null;
    },
    goBack: function goBack() {
      window.goBack(this);
    },
    setDate: function setDate(val) {
      return val !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).format(window.AppConfig.dateFormat) : '';
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_forms_TextInputDelBtn__ = __webpack_require__(300);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userIndex',
  components: {
    cServerTable: __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */],
    TextInputDelBtn: __WEBPACK_IMPORTED_MODULE_2__views_components_forms_TextInputDelBtn__["a" /* default */]
  },
  data: function data() {
    var config = __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['firstName', 'email', 'phone', 'isActive', 'actionButtons'],
      options: {
        headings: {
          firstName: 'Username',
          email: 'Email',
          phone: 'Phone',
          address: 'Address',
          unit: 'Unit',
          isActive: 'Availability',
          actionButtons: ''
        },
        templates: {
          firstName: function firstName(h, row) {
            return row.firstName + ' ' + window.setDefaultNull(row.lastName, '');
          }
        },
        sortable: ['username', 'role', 'isActive'],
        uniqueKey: 'uuid',
        params: {
          search: this.$route.query.search,
          role: 'admin'
        }
      }
    }, 'profile');

    return {
      apiUrl: window.AppConfig.apiUrl + 'profile',
      apiUrlUpdateStatus: window.AppConfig.apiUrl + 'user-activated',

      columns: config.columns,
      options: config.options,

      filterBy: {
        search: window.setDefaultNull(this.$route.query.search)
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    doFilter: function doFilter() {
      this.options.params.search = this.filterBy.search === '' ? null : this.filterBy.search;
      this.$refs.dataTable.setTableDatas();
    },
    doUpdateStatus: function doUpdateStatus(row) {
      var _this = this;

      var data = {
        uuid: row.uuid,
        isActive: !row.isActive ? 1 : 0
      };
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.apiUrlUpdateStatus, data).then(function (response) {
        row.isActive = data.isActive ? 1 : 0;
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextInputDelBtn_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bccfba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextInputDelBtn_vue__ = __webpack_require__(762);
function injectStyle (ssrContext) {
  __webpack_require__(761)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71bccfba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextInputDelBtn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71bccfba_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextInputDelBtn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
    type: {
      type: String,
      required: true,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    autocomplete: {
      type: String,
      required: false,
      default: null
    },
    ariaRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    ariaInvalid: {
      type: String,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      inputVal: this.value
    };
  },

  watch: {
    inputVal: function inputVal(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    clearVal: function clearVal() {
      this.inputVal = null;
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_1_axios___default.a,
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker___default.a
  },
  data: function data() {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'profile',

      showLoader: false,
      errorMsg: null,
      user: {
        uuid: {
          rule: '',
          value: this.$route.params.id
        },
        firstName: {
          rule: 'required editable',
          value: null,
          error: null
        },
        lastName: {
          rule: 'editable',
          value: null,
          error: null
        },
        address: {
          rule: 'editable',
          value: null,
          error: null
        },
        phone: {
          rule: 'required editable',
          value: null,
          error: null
        },
        email: {
          rule: 'required editable',
          value: null,
          error: null
        },
        password: {
          rule: 'required',
          value: null,
          error: null
        },
        relation: {
          rule: 'editable',
          value: null,
          error: null
        },
        gender: {
          rule: 'required editable',
          value: null,
          error: null
        },
        dob: {
          rule: 'editable',
          value: null,
          error: null
        },
        role: {
          rule: 'editable',
          value: 'admin',
          error: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.setEmptyForm();
    this.user.dob.value = __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD');
    this.user.address.value = 'mana saje';
    if (this.isEditMode) {
      this.getDetailInfo();
    }
  },

  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.getDetailInfo();
    }
  },
  methods: {
    onSubmitAdmin: function onSubmitAdmin() {
      var _this = this;

      this.$refs.progress.activateProgressBar();

      this.errorMsg = null;
      var hasError = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user);

      for (var i = 0; i < obj.length; i++) {
        var rule = this.user[obj[i]].rule;
        if ((!this.isEditMode && rule.indexOf('required') !== -1 || this.isEditMode && rule.indexOf('editable') !== -1 && rule.indexOf('required') !== -1) && (this.user[obj[i]].value == null || this.user[obj[i]].value == '')) {
            this.user[obj[i]].error = 'This field is required';
            hasError = true;
          } else {
          this.user[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[i]].error = null;
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar();
        this.$alertify.error('Failed! Please complete the message and submit again.');
        return false;
      }

      var Data = {};
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user).length; _i++) {
        var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.user)[_i];
        if (key === 'dob') {
          this.user[key].value = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.user[key].value).format('YYYY-MM-DD');
        }

        if (!this.isEditMode) {
          Data[key] = this.user[key].value;
        } else {
          if (this.user[key].rule.indexOf('editable') !== -1) {
            Data[key] = this.user[key].value;
          }
        }
      }
      if (!this.isEditMode) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.apiUrl, Data).then(function (response) {
          _this.$refs.progress.deactivateProgressBar();
          _this.setEmptyForm();
          window.setTimeout(function () {
            _this.$alertify.success('User has been added!');
          }, 2000);
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
        }).catch(function (error) {
          _this.doCollectErrMessage(error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.apiUrl + '/' + this.user.uuid.value, Data).then(function (response) {
          _this.$refs.progress.deactivateProgressBar();
          window.setTimeout(function () {
            _this.$alertify.success('User has been updated!');
          }, 2000);
          window.location.href = document.URL.replace('/edit', '');
        }).catch(function (error) {
          _this.$refs.progress.deactivateProgressBar();
          _this.doCollectErrMessage(error);
        });
      }
    },
    getDetailInfo: function getDetailInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrl + '/' + this.$route.params.id).then(function (response) {
        _this2.user.uuid.value = response.data.uuid;
        _this2.user.firstName.value = response.data.firstName;
        _this2.user.lastName.value = response.data.lastName;
        _this2.user.address.value = response.data.address;
        _this2.user.phone.value = response.data.phone;
        _this2.user.email.value = response.data.email;
        _this2.user.relation.value = response.data.relation;
        _this2.user.email.value = response.data.email;
        _this2.user.gender.value = response.data.gender;
        _this2.user.dob.value = response.data.dob;
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    setEmptyForm: function setEmptyForm() {
      this.user.firstName.value = null;
      this.user.lastName.value = null;
      this.user.address.value = null;
      this.user.phone.value = null;
      this.user.email.value = null;
      this.user.password.value = null;
      this.user.relation.value = null;
      this.user.gender.value = null;
      this.user.dob.value = null;
    },
    doCollectErrMessage: function doCollectErrMessage(error) {
      var _this3 = this;

      this.$refs.progress.deactivateProgressBar();
      this.$alertify.error('Failed! Please complete the message and submit again.');
      this.$store.dispatch('errorMessage', error).then(function (errMsg) {
        _this3.errorMsg = errMsg;
      });
    },
    goBack: function goBack() {
      window.goBack(this);
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a
  },
  data: function data() {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'profile',
      user: {
        uuid: '',
        firstName: '',
        lastName: '',
        address: '',
        phone: '',
        relation: '',
        email: ''
      }
    };
  },
  mounted: function mounted() {
    this.getDetailInfo();
  },

  methods: {
    getDetailInfo: function getDetailInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        window.setDetailValue(_this.user, response.data);
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    goBack: function goBack() {
      window.goBack(this);
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_forms_TextInputDelBtn__ = __webpack_require__(300);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tenantIndex',
  components: {
    cServerTable: __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */],
    TextInputDelBtn: __WEBPACK_IMPORTED_MODULE_2__views_components_forms_TextInputDelBtn__["a" /* default */]
  },
  data: function data() {
    var config = __WEBPACK_IMPORTED_MODULE_1__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['firstName', 'phone', 'isActive', 'actionButtons'],
      options: {
        headings: {
          firstName: 'Name',
          phone: 'Phone',
          address: 'Address',
          locationGroup: 'Location Group',
          unit: 'Unit',
          isActive: 'Status',
          actionButtons: ''
        },
        uniqueKey: 'uuid',
        params: {
          search: this.$route.query.search,
          address: this.$route.query.address,
          role: 'contractor',
          parent: null,
          location_group_uuid: this.$route.query.location_group_uuid
        },
        templates: {
          firstName: function firstName(h, row) {
            return row.firstName + ' ' + window.setDefaultNull(row.lastName, '');
          },
          locationGroup: function locationGroup(h, row) {
            return row.locationGroup === null ? '-' : row.locationGroup.name;
          }
        },
        sortable: ['firstName', 'isActive'],
        groupBy: 'parent',
        groupMeta: []
      }
    }, 'profile');

    return {
      apiUrl: window.AppConfig.apiUrl + 'profile',
      apiUrlDelete: window.AppConfig.apiUrl + 'tenant',
      apiUrlUpdateStatus: window.AppConfig.apiUrl + 'user-activated',
      apiUrlLocationGroupList: window.AppConfig.apiUrl + 'location-group',

      columns: config.columns,
      options: config.options,

      filterBy: {
        locationGroupList: [],
        search: window.setDefaultNull(this.$route.query.search),
        address: window.setDefaultNull(this.$route.query.address),
        filterLocationGroup: window.setDefaultNull(this.$route.query.location_group_uuid)
      },
      statusReason: {
        hasError: false,
        row: null,
        note: null,
        showLoader: false
      }
    };
  },
  mounted: function mounted() {
    this.initDropdownOptions_Group();
  },

  methods: {
    initDropdownOptions_Group: function initDropdownOptions_Group() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlLocationGroupList).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.locationGroup;
          for (var i = 0; i < response.data.total_items; i++) {
            _this.filterBy.locationGroupList.push({ text: datas[i].name, value: datas[i].uuid });
          }
        }
      }).catch(function (error) {
        var _this2 = this;

        this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    doFilter: function doFilter() {
      this.options.params.location_group_uuid = window.setDefaultNull(this.filterBy.filterLocationGroup);
      this.options.params.search = this.filterBy.search === '' ? null : this.filterBy.search;
      this.options.params.address = this.filterBy.address === '' ? null : this.filterBy.address;
      this.$refs.dataTable.setTableDatas();
    },
    openStatusReasonModal: function openStatusReasonModal(row) {
      this.statusReason.showLoader = false;
      this.statusReason.hasError = false;
      this.statusReason.row = row;
      this.statusReason.note = null;
      this.$refs.statusReasonModal.show();
    },
    doUpdateStatus: function doUpdateStatus() {
      var _this3 = this;

      if (!this.statusReason.showLoader) {
        if (this.statusReason.note !== '' && this.statusReason.note !== null) {
          this.statusReason.hasError = false;
          this.statusReason.showLoader = true;
          var data = {
            uuid: this.statusReason.row.uuid,
            note: this.statusReason.note,
            isActive: !this.statusReason.row.isActive ? 1 : 0
          };
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.apiUrlUpdateStatus, data).then(function (response) {
            _this3.statusReason.row.isActive = data.isActive ? 1 : 0;
            _this3.statusReason.showLoader = false;
            _this3.statusReason.hasError = false;
            _this3.statusReason.row = null;
            _this3.statusReason.note = null;
            _this3.$refs.statusReasonModal.hide();
          }).catch(function (error) {
            window.consoleLog(error);
            _this3.statusReason.showLoader = false;
            _this3.statusReason.hasError = error;
          });
        } else {
          this.statusReason.showLoader = false;
          this.statusReason.hasError = 'Please complete all required fields';
        }
      }
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_progressLoader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_toggle_button__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_nationalityListInit__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_components_nationalityListInit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_components_nationalityListInit__);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_js_toggle_button___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tenantCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_2_axios___default.a,
    progressLoader: __WEBPACK_IMPORTED_MODULE_3__views_components_progressLoader__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_5_vue2_datepicker___default.a
  },
  data: function data() {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'profile',
      apiUrlGetDetail: window.AppConfig.apiUrl + 'profile',

      showLoader: false,
      errorMsg: null,
      tenant: {
        uuid: {
          rule: '',
          value: this.$route.params.id
        },
        firstName: {
          rule: 'required editable',
          value: null,
          error: null
        },
        lastName: {
          rule: 'editable',
          value: null,
          error: null
        },
        address: {
          rule: 'editable',
          value: null,
          error: null
        },
        phone: {
          rule: 'required editable',
          value: null,
          error: null
        },
        mobile: {
          rule: 'editable',
          value: null,
          error: null
        },
        email: {
          rule: 'required editable',
          value: null,
          error: null
        },
        password: {
          rule: 'required',
          value: null,
          error: null
        },
        relation: {
          rule: 'editable',
          value: null,
          error: null
        },
        gender: {
          rule: 'required editable',
          value: null,
          error: null
        },
        dob: {
          rule: 'editable',
          value: null,
          error: null
        },
        identityType: {
          rule: 'editable',
          value: null,
          error: null
        },
        identityNumber: {
          rule: 'editable',
          value: null,
          error: null
        },
        nationality: {
          rule: 'editable',
          value: null,
          error: null
        },
        bloodType: {
          rule: 'editable',
          value: null,
          error: null
        },
        unit: {
          rule: 'editable',
          value: null,
          error: null
        },
        role: {
          rule: 'role',
          value: 'contractor',
          error: null
        }
      },
      nationalityList: []
    };
  },
  mounted: function mounted() {
    this.initDropdownOptions_Nationality();
    window.setEmptyForm(this.tenant);
    this.tenant.dob.value = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYYY-MM-DD');
    this.tenant.address.value = 'mana saje';
    this.tenant.role.value = 'contractor';
    if (this.isEditMode) {
      this.getDetailInfo();
    }
  },

  methods: {
    initDropdownOptions_Nationality: function initDropdownOptions_Nationality() {
      var datas = __WEBPACK_IMPORTED_MODULE_7__views_components_nationalityListInit___default.a;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(datas).map(function (name, index) {
        self.nationalityList.push({ text: name, value: datas[name] });
      });
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs.progress.activateProgressBar();

      this.errorMsg = null;
      var hasError = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tenant);

      for (var i = 0; i < obj.length; i++) {
        var rule = this.tenant[obj[i]].rule;
        if ((!this.isEditMode && rule.indexOf('required') !== -1 || this.isEditMode && rule.indexOf('editable') !== -1 && rule.indexOf('required') !== -1) && (this.tenant[obj[i]].value === null || this.tenant[obj[i]].value === '')) {
          this.tenant[obj[i]].error = 'This field is required';
          hasError = true;
        } else {
          this.tenant[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tenant)[i]].error = null;
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar();
        this.$alertify.error('Failed! Please complete the message and submit again.');
        return false;
      }

      var Data = {};
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tenant).length; _i++) {
        var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.tenant)[_i];
        if (key === 'dob') {
          this.tenant[key].value = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.tenant[key].value).format('YYYY-MM-DD');
        }

        if (!this.isEditMode) {
          Data[key] = this.tenant[key].value;
        } else {
          if (this.tenant[key].rule.indexOf('editable') !== -1) {
            Data[key] = this.tenant[key].value;
          }
        }
      }
      if (!this.isEditMode) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.apiUrl, Data).then(function (response) {
          _this.$refs.progress.deactivateProgressBar();
          window.setEmptyForm(_this.tenant);
          window.setTimeout(function () {
            _this.$alertify.success('Contractor has been added!');
          }, 2000);
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
        }).catch(function (error) {
          _this.$refs.progress.deactivateProgressBar();
          _this.doCollectErrMessage(error);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(this.apiUrl + '/' + this.tenant.uuid.value, Data).then(function (response) {
          _this.$refs.progress.deactivateProgressBar();
          window.setTimeout(function () {
            _this.$alertify.success('Contractor has been updated!');
          }, 2000);
          window.location.href = document.URL.replace('/edit', '');
        }).catch(function (error) {
          _this.$refs.progress.deactivateProgressBar();
          _this.doCollectErrMessage(error);
        });
      }
    },
    getDetailInfo: function getDetailInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        window.setDetailValue(_this2.tenant, response.data);
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    doCollectErrMessage: function doCollectErrMessage(error) {
      var _this3 = this;

      this.$alertify.error('Failed! Please complete the message and submit again.');
      this.$store.dispatch('errorMessage', error).then(function (errMsg) {
        _this3.errorMsg = errMsg;
      });
    },
    goBack: function goBack() {
      window.goBack(this);
    }
  }
});

/***/ }),
/* 306 */,
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tenantDetail',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_1_axios___default.a,
    cServerTable: __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */]
  },
  data: function data() {
    var billingTableconfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['billingCycle', 'period', 'title', 'issuedBy', 'dueDate', 'billingStatus', 'billingDetailButton'],
      options: {
        headings: {
          'period': 'Period',
          'title': 'Title',
          'issuedBy': 'Issued By',
          'dueDate': 'Due Date',
          'billingCycle': 'Cycle',
          'billingStatus': 'Status',
          'billingDetailButton': ''
        },
        sortable: [],
        uniqueKey: 'uuid',
        templates: {
          dueDate: function dueDate(h, row) {
            return row.dueDate !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.dueDate).format(window.AppConfig.dateFormat) : '-';
          }
        }
      }
    }, 'billing');

    var visitorTableconfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['name', 'typeText', 'visitStartTime', 'visitEndTime', 'visitorStatus', 'createdAt', 'actionButtonsVisitorTenant3'],
      options: {
        headings: {
          name: 'Name',
          typeText: 'Visitor Type',
          visitStartTime: 'Check In Time',
          visitEndTime: 'Check Out Time',
          visitorStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsVisitorTenant3: ''
        },
        sortable: ['name', 'createdAt', 'visitStartTime', 'visitEndTime'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          visitor_status_uuid: this.$route.query.visitor_status_uuid,
          visitor_type_uuid: this.$route.query.visitor_type_uuid
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.createdAt !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          },
          visitStartTime: function visitStartTime(h, row) {
            return row.visitStartTime !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.visitStartTime).format(window.AppConfig.dateFormat) : '-';
          },
          visitEndTime: function visitEndTime(h, row) {
            return row.visitEndTime !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.visitEndTime).format(window.AppConfig.dateFormat) : '-';
          }
        }
      }
    }, 'visitor');

    var complaintTableconfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['place', 'description', 'complainStatus', 'createdAt', 'actionButtonsComplaintTenant3'],
      options: {
        headings: {
          place: 'Location',
          description: 'Description',
          complainStatus: 'Status',
          createdAt: 'Created Time',
          actionButtonsComplaintTenant3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          complain_status_uuid: this.$route.query.complain_status_uuid,
          complain_category_uuid: this.$route.query.complain_category_uuid
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.createdAt !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          },
          userProfile: function userProfile(h, row) {
            return row.userProfile.firstName + ' ' + window.setDefaultNull(row.userProfile.lastName);
          }
        }
      }
    }, 'complain');

    var requestTableconfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['title', 'address', 'requestCategory', 'requestStatus', 'createdAt', 'actionButtonsRequestTenant3'],
      options: {
        headings: {
          title: 'Title',
          address: 'Address',
          requestCategory: 'Category',
          requestStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsRequestTenant3: ''
        },
        sortable: ['createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_date: this.$route.query.start_date,
          end_date: this.$route.query.end_date,
          request_status_uuid: this.$route.query.request_status_uuid,
          request_category_uuid: this.$route.query.request_category_uuid,
          address: this.$route.query.search
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.createdAt !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          },
          account: function account(h, row) {
            return window.setDefaultNull(row.account.name);
          },
          requestedBy: function requestedBy(h, row) {
            return window.setDefaultNull(row.requestedBy.name);
          },
          address: function address(h, row) {
            return window.setDefaultNull(row.requestedBy.address);
          }
        }
      }
    }, 'request');

    var bookingTableconfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['facility', 'startTime', 'endTime', 'facilityBookingStatus', 'createdAt', 'actionButtonsBookingTenant3'],
      options: {
        headings: {
          facility: 'Site',
          startTime: 'Start Time',
          endTime: 'End Time',
          facilityBookingStatus: 'Status',
          createdAt: 'Requested Time',
          actionButtonsBookingTenant3: ''
        },
        sortable: ['startTime', 'endTime', 'createdAt'],
        uniqueKey: 'uuid',
        params: {
          start_time: this.$route.query.startTime,
          end_time: this.$route.query.endTime,
          facility_booking_status_uuid: this.$route.query.facility_booking_status_uuid,
          facility_uuid: this.$route.query.facility_uuid
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.startTime !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          },
          startTime: function startTime(h, row) {
            return row.startTime !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.startTime).format(window.AppConfig.dateFormat) : '-';
          },
          endTime: function endTime(h, row) {
            return row.startTime !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.endTime).format(window.AppConfig.dateFormat) : '-';
          },
          userProfile: function userProfile(h, row) {
            return row.userProfile.firstName + ' ' + window.setDefaultNull(row.userProfile.lastName);
          }
        }
      }
    }, 'facilityBooking');

    var cServerTableConfig = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['createdAt', 'changedBy', 'note', 'isActiveStatusHistory'],
      options: {
        headings: {
          createdAt: 'Date Time',
          changedBy: 'Changed By',
          note: 'Note',
          isActiveStatusHistory: 'Action'
        },
        uniqueKey: 'uuid',
        params: {
          user_profile_uuid: this.$route.params.id
        },
        templates: {
          createdAt: function createdAt(h, row) {
            return row.createdAt !== null ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(row.createdAt).format(window.AppConfig.dateFormat) : '-';
          }
        }
      }
    }, 'userActivatedLog');

    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'profile',
      apiUrlGetStatusHistories: window.AppConfig.apiUrl + 'user-activated-log',
      apiUrlGetChildTenant: window.AppConfig.apiUrl + 'profile?role=contractor&parent=',
      apiUrlGetBillings: window.AppConfig.apiUrl + 'billing?user_profile_uuid=',
      apiUrlGetVisitors: window.AppConfig.apiUrl + 'visitor?ascending=1&requestedBy=',
      apiUrlGetComplaints: window.AppConfig.apiUrl + 'complain?ascending=1&userProfile=',
      apiUrlRequests: window.AppConfig.apiUrl + 'request?ascending=1&requestedBy=',
      apiUrlGetFacilityBookings: window.AppConfig.apiUrl + 'facility-booking?ascending=1&userProfile=',
      apiUrl: window.AppConfig.apiUrl + 'request',
      tenant: {
        uuid: null,
        firstName: null,
        lastName: null,
        gender: null,
        dob: null,
        phone: null,
        mobile: null,
        address: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        username: null,
        email: null,
        parent: null,
        relation: null,
        createdAt: null,
        updatedAt: null,
        identityNumber: null,
        identityType: null,
        nationality: null,
        bloodType: null,
        unit: null
      },
      childTenant: [],
      columns: cServerTableConfig.columns,
      options: cServerTableConfig.options,
      billings: [],
      billingTableColumns: billingTableconfig.columns,
      billingTableOptions: billingTableconfig.options,
      visitors: [],
      visitorTableColumns: visitorTableconfig.columns,
      visitorTableOptions: visitorTableconfig.options,
      complaints: [],
      complaintTableColumns: complaintTableconfig.columns,
      complaintTableOptions: complaintTableconfig.options,
      requests: [],
      requestTableColumns: requestTableconfig.columns,
      requestTableOptions: requestTableconfig.options,
      bookings: [],
      bookingTableColumns: bookingTableconfig.columns,
      bookingTableOptions: bookingTableconfig.options,
      filterBy: {
        DateTime: window.setDefaultNull(this.$route.query.start_date) === null ? null : [window.setDefaultNull(this.$route.query.start_date), window.setDefaultNull(this.$route.query.end_date)],
        requestStatusList: [],
        requestCategoryList: [],
        request_status_uuid: window.setDefaultNull(this.$route.query.request_status_uuid),
        request_category_uuid: window.setDefaultNull(this.$route.query.request_category_uuid),
        DateTimeNotAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
        address: window.setDefaultNull(this.$route.query.address)
      }
    };
  },
  mounted: function mounted() {
    this.getDetailInfo();
    this.getChildTenant();
  },

  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.getDetailInfo();
    }
  },
  methods: {
    getDetailInfo: function getDetailInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        window.setDetailValue(_this.tenant, response.data);
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    getChildTenant: function getChildTenant() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.apiUrlGetChildTenant + this.$route.params.id).then(function (response) {
        _this2.childTenant = response.data._embedded.profile;
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    getStatusColor: function getStatusColor(status) {
      if (status) {
        return 'success';
      } else {
        return 'secondary';
      }
    },
    getStatusColorVisitor: function getStatusColorVisitor(status) {
      switch (status) {
        case 'Check In':
          return 'success';
        case 'Check Out':
          return 'secondary';
        case 'Registered':
          return 'primary';
        default:
          return 'dark';
      }
    },
    getStatusColorComplaint: function getStatusColorComplaint(status) {
      switch (status) {
        case 'Pending':
          return 'warning';
        case 'In Progress':
          return 'primary';
        case 'Resolved':
          return 'success';
        default:
          return 'danger';
      }
    },
    getStatusColorRequest: function getStatusColorRequest(status) {
      switch (status) {
        case 'Pending':
          return 'warning';
        case 'Approved':
          return 'success';
        default:
          return 'danger';
      }
    },
    getStatusColorBooking: function getStatusColorBooking(value) {
      switch (value) {
        case 'Requested':
          return 'primary';
        case 'Rejected':
          return 'danger';
        case 'Approved':
          return 'success';
        case 'Check In':
          return 'info';
        case 'Check Out':
          return 'dark';
        case 'Cancelled':
          return 'warning';
        default:
          return 'light';
      }
    },
    getTypeColorVisitor: function getTypeColorVisitor(type) {
      switch (type) {
        case 'Friend':
          return 'success';
        case 'Sub Contractor':
          return 'light';
        case 'Family':
          return 'primary';
        default:
          return 'dark';
      }
    },
    getCycleColor: function getCycleColor(val) {
      switch (val) {
        case 'First':
          return 'primary';
        case 'Second':
          return 'info';
        case 'Third':
          return 'secondary';
        default:
          return 'light';
      }
    },
    getFlagColor: function getFlagColor(val) {
      switch (val) {
        case 'Overdue':
          return 'danger';
        case 'Dispute':
          return 'warning';
        default:
          return 'transparent';
      }
    },
    getBillingStatusColor: function getBillingStatusColor(val) {
      switch (val) {
        case 'Paid':
          return 'success';
        case 'Pending':
          return 'warning';
        case 'New':
          return 'primary';
        case 'Refunded':
          return 'info';
        case 'Cancelled':
          return 'danger';
        default:
          return 'secondary';
      }
    },
    isAnyParent: function isAnyParent() {
      return this.tenant.parent !== null && this.tenant.parent !== '';
    },
    doRequestApproval: function doRequestApproval(row, status, note) {
      var _this3 = this;

      if (status === 'Rejected' && note === '') {
        this.$alertify.error('Can\'t Update. Reject Note is Required.');
        return false;
      } else {
        var listStatus = this.filterBy.requestStatusList;
        var uuidStatus = null;
        for (var i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value;
        }
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.apiUrl + '/' + row.uuid, {
          requestStatus: uuidStatus,
          note: note
        }).then(function (response) {
          _this3.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>');
          row.requestStatus = status;
        }).catch(function (error) {
          _this3.$store.dispatch('errorMessage', error).then(function (errMsg) {
            _this3.$alertify.error(errMsg);
          });
        });
      }
    },
    doConfirmRejecting: function doConfirmRejecting(row) {
      var _this4 = this;

      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '', function (evt, value) {
        return _this4.doRequestApproval(row, 'Rejected', value);
      });
    },
    doBookingApprovalBooking: function doBookingApprovalBooking(row, status, note) {
      var _this5 = this;

      if (status === 'Rejected' && note === '') {
        this.$alertify.error('Can\'t Update. Reject Note is Required.');
        return false;
      } else {
        var listStatus = this.filterBy.facilityBookingStatusList;
        var uuidStatus = null;
        for (var i = 0; i < listStatus.length; i++) {
          if (listStatus[i].text === status) uuidStatus = listStatus[i].value;
        }
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(this.apiUrl + '/' + row.uuid, {
          facilityBookingStatus: uuidStatus,
          bookingNote: note
        }).then(function (response) {
          _this5.$alertify.success('Successfully updated. <br />Status: ' + '<b>' + status + '</b>');
          row.facilityBookingStatus = status;
        }).catch(function (error) {
          _this5.$store.dispatch('errorMessage', error).then(function (errMsg) {
            _this5.$alertify.error(errMsg);
          });
        });
      }
    },
    doConfirmRejectingBooking: function doConfirmRejectingBooking(row) {
      var _this6 = this;

      this.$alertify.prompt('Reject Note <span style="color:red">*</span>', '', function (evt, value) {
        return _this6.doBookingApproval(row, 'Rejected', value);
      });
    },
    goBack: function goBack() {
      window.goBack(this);
    },
    goToDetail: function goToDetail(uuid) {
      this.$router.push('/settings/user/contractors/' + uuid);
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__ = __webpack_require__(33);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userIndex',
  components: {
    cServerTable: __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */]
  },
  data: function data() {
    var config = __WEBPACK_IMPORTED_MODULE_0__views_components_cServerTable__["a" /* default */].methods.setTableConfig({
      columns: ['name', 'description', 'isAvailable', 'actionButtons'],
      options: {
        headings: {
          isAvailable: 'Available',
          actionButtons: ''
        },
        sortable: ['name'],
        uniqueKey: 'uuid',
        params: {},
        templates: {
          openTime: function openTime(h, row) {
            return window.setDefaultNull(row.openTime, '-');
          },
          closedTime: function closedTime(h, row) {
            return window.setDefaultNull(row.closedTime, '-');
          }
        }
      }
    }, 'site');

    return {
      apiUrl: window.AppConfig.apiUrl + 'site',

      columns: config.columns,
      options: config.options,

      filterBy: {
        available: '1'
      }
    };
  },
  mounted: function mounted() {},

  methods: {
    doFilter: function doFilter() {
      this.options.params.avaiable = this.filterBy.available === '1' ? null : this.filterBy.available;
      this.$refs.dataTable.setTableDatas();
    }
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_components_progressLoader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button__);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'facilityCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_2_axios___default.a,
    progressLoader: __WEBPACK_IMPORTED_MODULE_3__views_components_progressLoader__["a" /* default */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_4_vue2_timepicker___default.a
  },
  data: function data() {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'site',
      apiUrlGetDetail: window.AppConfig.apiUrl + 'site',

      showLoader: false,
      errorMsg: null,
      facility: {
        uuid: {
          rule: 'editable',
          value: this.$route.params.id
        },
        name: {
          rule: 'required editable',
          value: null,
          error: null
        },
        description: {
          rule: 'required editable',
          value: null,
          error: null
        },
        address: {
          rule: 'required editable',
          value: null,
          error: null
        },
        icon: {
          rule: 'required editable',
          value: null,
          error: null
        },
        isAvailable: {
          rule: 'required editable',
          value: 0,
          tempValue: true,
          error: null
        }
      }
    };
  },
  mounted: function mounted() {
    this.setEmptyForm();
    if (this.isEditMode) {
      this.getDetailInfo();
    }
  },

  methods: {
    onSubmit: function onSubmit() {
      this.errorMsg = null;
      var hasError = false;
      var obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.facility);
      this.facility.isAvailable.value = this.facility.isAvailable.tempValue ? 1 : 0;

      for (var i = 0; i < obj.length; i++) {
        var rule = this.facility[obj[i]].rule;
        if ((rule.indexOf('required') !== -1 || this.isEditMode && rule.indexOf('editable') !== -1 && rule.indexOf('required') !== -1) && (this.facility[obj[i]].value === null || this.facility[obj[i]].value === '' || this.facility[obj[i]].value.HH === null)) {
          this.facility[obj[i]].error = 'This field is required';
          hasError = true;
        } else {
          this.facility[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.facility)[i]].error = null;
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar();
        this.$alertify.error('Failed! Please complete the message and submit again.');
        return false;
      }

      var formData = new FormData();
      for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.facility).length; _i++) {
        var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.facility)[_i];
        if (this.facility[key].value !== null && key !== 'uuid') {
          if (key.indexOf('Time') >= 0) {
            formData.append(key, this.facility[key].value.HH + ':' + this.facility[key].value.mm);
          } else if (key.indexOf('icon') >= 0) {
            if (typeof this.facility[key].value !== 'string') {
              formData.append(key, this.facility[key].value);
            }
          } else {
            formData.append(key, this.facility[key].value);
          }
        }
      }
      var self = this;
      self.$refs.progress.activateProgressBar();

      if (!this.isEditMode) {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.apiUrl, formData).then(function (response) {
          self.$refs.progress.deactivateProgressBar();
          self.setEmptyForm();
          window.setTimeout(function () {
            self.$alertify.success('Site has been added!');
          }, 2000);
          window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
        }).catch(function (error) {
          self.doCollectErrMessage(error);
        });
      } else {
        self.$refs.progress.deactivateProgressBar();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.patch(this.apiUrl + '/' + this.facility.uuid.value, formData).then(function (response) {
          window.setTimeout(function () {
            self.$alertify.success('Site has been updated!');
          }, 2000);
          window.location.href = document.URL.replace('/edit', '');
        }).catch(function (error) {
          self.doCollectErrMessage(error);
        });
      }
    },
    getDetailInfo: function getDetailInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        _this.facility.uuid.value = response.data.uuid;
        _this.facility.name.value = response.data.name;
        _this.facility.description.value = response.data.description;
        _this.facility.address.value = response.data.address;
        _this.facility.icon.value = response.data.icon;
        _this.getImageURL('icon', response.data.icon);
        _this.facility.isAvailable.tempValue = !!response.data.isAvailable;
        _this.facility.isAvailable.value = response.data.isAvailable;
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    getImageURL: function getImageURL(imgId, optionalUrl) {
      var input = null;
      var objImg = document.getElementById(imgId);
      input = document.getElementById('inputIcon');

      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = function (e) {
          objImg.setAttribute('src', e.target.result);
        };
        reader.readAsDataURL(input.files[0]);
      } else {
        objImg.setAttribute('src', optionalUrl);
      }
    },
    setEmptyForm: function setEmptyForm() {
      this.facility.uuid.value = null;
      this.facility.name.value = null;
      this.facility.description.value = null;
      this.facility.address.value = null;
      this.facility.icon.value = null;
      this.$refs.icon.reset();
      this.getImageURL('icon', null);
      this.facility.isAvailable.tempValue = true;
      this.facility.isAvailable.value = 1;
    },
    doCollectErrMessage: function doCollectErrMessage(error) {
      var _this2 = this;

      this.$alertify.error('Failed! Please complete the message and submit again.');
      this.$store.dispatch('errorMessage', error).then(function (errMsg) {
        _this2.errorMsg = errMsg;
      });
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(9);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(311);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'facilityCreate',
  components: {
    axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a
  },
  data: function data() {
    return {
      apiUrlGetDetail: window.AppConfig.apiUrl + 'site',
      facility: {
        uuid: '',
        name: '',
        description: '',
        address: '',
        isAvailable: '',
        isAvailableOnHoliday: '',
        openTime: '',
        closedTime: '',
        icon: '',
        iconMedium: '',
        iconLarge: '',
        createAt: '',
        updateAt: '',
        qrCode: '',
        account: ''
      },
      showPrintQrCode: false
    };
  },
  mounted: function mounted() {
    this.getDetailInfo();
  },

  watch: {
    '$route.params.id': function $routeParamsId(id) {
      this.getDetailInfo();
    }
  },
  methods: {
    getDetailInfo: function getDetailInfo() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetDetail + '/' + this.$route.params.id).then(function (response) {
        window.setDetailValue(_this.facility, response.data);
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
        window.history.back();
      });
    },
    goBack: function goBack() {
      window.goBack(this);
    },
    actionToQrCode: function actionToQrCode(action) {
      var _this2 = this;

      var canvas = document.getElementById('qrCodeCanvas');
      var context = canvas.getContext('2d');
      var imageObj = new Image();
      imageObj.onload = function () {
        context.drawImage(imageObj, 0, 0, 500, 500);
        context.font = '20px Arial';
        context.textAlign = 'center';
        context.fillText(_this2.facility.name, 250, 470, 500);
        if (action === 'download') {
          var link = document.createElement('a');
          link.download = _this2.facility.name + '.jpeg';
          link.href = document.getElementById('qrCodeCanvas').toDataURL('image/jpeg', 1.0);
          link.click();
        } else {
          _this2.showPrintQrCode = true;
          setTimeout(function () {
            document.body.style.height = document.querySelector('#printQrCode').clientHeight + 'px';
            window.print();
          }, 100);
        }
      };
      imageObj.src = this.facility.qrCode;
    },
    closeQrCodePrinter: function closeQrCodePrinter() {
      this.showPrintQrCode = false;
      document.body.style.height = null;
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components___);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["Header"],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["Sidebar"],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["Aside"],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["Footer"]
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    nav: function nav() {
      return __WEBPACK_IMPORTED_MODULE_0__nav___default.a.items;
    },
    isOtherPage: function isOtherPage() {
      var isPage = this.$route.name.indexOf('Page') > -1;

      return isPage;
    }
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_notifications_Index__ = __webpack_require__(793);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'aside',
  components: {
    NotificationList: __WEBPACK_IMPORTED_MODULE_0__views_notifications_Index__["a" /* default */]
  },
  methods: {
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotificationsIndex',
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker___default.a
  },
  data: function data() {
    return {
      notificationList: [],
      page: 1,
      lastPage: false
    };
  },
  mounted: function mounted() {
    this.getNotificationList();
  },

  methods: {
    getNotificationList: function getNotificationList() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(window.AppConfig.apiUrl + 'notification?admin=1&limit=10&page=' + this.page).then(function (response) {
        if (response === undefined) return false;
        if (response.data.page === response.data.page_count) {
          _this.lastPage = true;
        }
        if (_this.page === 1) {
          _this.notificationList = [];
        }
        for (var i = 0; i < response.data._embedded.notification.length; i++) {
          var url = null;
          if (response.data._embedded.notification[i].type === 'Facility') {
            url = '#/facility-booking/' + response.data._embedded.notification[i].facilityBooking;
          } else if (response.data._embedded.notification[i].type === 'Complain') {
            url = '#/complaint/' + response.data._embedded.notification[i].complain;
          } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'PanicResolve') {
            url = '#/panic-alerts/' + response.data._embedded.notification[i].panicAlert;
          } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'Request') {
            url = '#/request/' + response.data._embedded.notification[i]._embedded.request.uuid;
          } else if (response.data._embedded.notification[i].type === 'Task') {
            url = '#/tasks/' + response.data._embedded.notification[i]._embedded.task.uuid;
          } else {
            url = '#/visitor/' + response.data._embedded.notification[i].visitor;
          }
          _this.notificationList.push({
            uuid: response.data._embedded.notification[i].uuid,
            userProfile: response.data._embedded.notification[i].userProfile,
            title: response.data._embedded.notification[i].title,
            createdAt: __WEBPACK_IMPORTED_MODULE_1_moment___default()(response.data._embedded.notification[i].createdAt).from(__WEBPACK_IMPORTED_MODULE_1_moment___default()().format()),
            href: url,
            unread: response.data._embedded.notification[i].unread
          });
        }
      }).catch(function (error) {
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    doFilter: function doFilter() {
      this.page = 1;
      if (this.filterBy.DateTime !== null && this.filterBy.DateTime !== '') {
        this.params.start_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.filterBy.DateTime[0]).format('YYYY-MM-DD');
        this.params.end_date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.filterBy.DateTime[1]).format('YYYY-MM-DD');
      } else {
        this.params.start_date = null;
        this.params.end_date = null;
      }
      this.$router.replace({ query: window.setUrlParams(this.params) });
      this.getNotificationList();
    },
    readNotification: function readNotification(uuid, notification) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch(window.AppConfig.apiUrl + 'notification/' + uuid, { unread: 0 }).then(function (response) {
        notification.unread = false;
      });
      window.location.href = notification.href;
    },
    loadMore: function loadMore() {
      this.page++;
      this.getNotificationList();
    }
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(317);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcfd55a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(797);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dcfd55a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isFirst: function isFirst(index) {
      return index === 0;
    },
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer'
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderDropdown_vue__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderNotification_vue__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NotificationBubble__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumb_vue__ = __webpack_require__(316);








var numeral = __webpack_require__(811);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_2__HeaderDropdown_vue__["a" /* default */],
    HeaderNotification: __WEBPACK_IMPORTED_MODULE_3__HeaderNotification_vue__["a" /* default */],
    NotificationBubble: __WEBPACK_IMPORTED_MODULE_4__NotificationBubble__["a" /* default */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_5__Breadcrumb_vue__["default"]
  },
  data: function data() {
    return {
      notificationList: []
    };
  },

  computed: {
    list: function list() {
      return this.$route.matched;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    document.addEventListener('keydown', function (event) {
      if (event.keyCode === 115) {
        event.preventDefault();
        _this.fullScreenMode();
      }
    });
  },

  methods: {
    fullScreenMode: function fullScreenMode() {
      document.body.classList.toggle('header-hidden');
      document.body.classList.toggle('sidebar-hidden');
    },
    headerToggle: function headerToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('header-hidden');
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();

      document.body.classList.toggle('sidebar-minimized');
      document.body.classList.toggle('brand-minimized');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    },
    getUnreadNotificationList: function getUnreadNotificationList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(window.AppConfig.apiUrl + 'notification?admin=1&unread=1&limit=10').then(function (response) {
        if (response === undefined) return false;
        _this2.notificationList = [];

        for (var i = 0; i < response.data._embedded.notification.length; i++) {
          var uuid = null;
          if (response.data._embedded.notification[i].type === 'Facility') {
            uuid = response.data._embedded.notification[i].facilityBooking;
          } else if (response.data._embedded.notification[i].type === 'Complain') {
            uuid = response.data._embedded.notification[i].complain;
          } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'PanicResolve') {
            uuid = response.data._embedded.notification[i].panicAlert;
          } else if (response.data._embedded.notification[i].type === 'Panic' || response.data._embedded.notification[i].type === 'Request') {
            uuid = response.data._embedded.notification[i]._embedded.request.uuid;
          } else if (response.data._embedded.notification[i].type === 'Task') {
            uuid = response.data._embedded.notification[i]._embedded.task.uuid;
          } else {
            uuid = response.data._embedded.notification[i].visitor;
          }
          _this2.notificationList.push({
            notificationUuid: response.data._embedded.notification[i].uuid,
            uuid: uuid,
            userProfile: response.data._embedded.notification[i].userProfile,
            title: response.data._embedded.notification[i].title,
            createdAt: __WEBPACK_IMPORTED_MODULE_0_moment___default()(response.data._embedded.notification[i].createdAt).from(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format()),
            type: response.data._embedded.notification[i].type
          });
        }
        _this2.$refs.headerNotification.setNotificationList(_this2.notificationList);
        _this2.$refs.headerNotification.setNotificationTotals(numeral(response.data.total_items).format('0a'));
      }).catch(function (error) {
        _this2.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    afterClickNotification: function afterClickNotification(notificationUuid, uuid, type) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch(window.AppConfig.apiUrl + 'notification/' + notificationUuid, { unread: 0 }).then(function (response) {
        _this3.getUnreadNotificationList();
      });
      if (type !== 'browserNotif') {
        if (type === 'Facility') {
          window.location.href = '#/visited-sites/' + uuid;
        } else if (type === 'Complain') {
          window.location.href = '#/complaint/' + uuid;
        } else if (type === 'Panic' || type === 'PanicResolve') {
          window.location.href = '#/panic-alerts/' + uuid;
        } else if (type === 'Request') {
          window.location.href = '#/request/' + uuid;
        } else if (type === 'Task') {
          window.location.href = '#/tasks/' + uuid;
        } else {
          window.location.href = '#/visitor/' + uuid;
        }
      }
    }
  }
});

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown'
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-notification',
  props: {
    afterClickNotification: {
      type: Function
    }
  },
  data: function data() {
    return {
      notificationList: [],
      notificationTotals: null,
      setReadNotificationUuid: null,
      isRinging: false
    };
  },

  methods: {
    setNotificationList: function setNotificationList(data) {
      this.notificationList = data;
    },
    setNotificationTotals: function setNotificationTotals(data) {
      this.notificationTotals = data;
    },
    readNotification: function readNotification(notificationUuid, uuid, type) {
      this.afterClickNotification(notificationUuid, uuid, type);
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  },
  mounted: function mounted() {
    if (this.$route.query.notification_uuid !== undefined) {
      this.readNotification(this.$route.query.notification_uuid, null, 'browserNotif');
    }
  }
});

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notificationbubble',
  data: function data() {
    return {
      notifications: [],
      limit: 6
    };
  },

  props: {
    afterClickNotification: {
      type: Function
    }
  },
  methods: {
    removeThis: function removeThis(index) {
      if (this.notifications[index].isClose) {
        this.notifications[index].isHide = true;
      }
    },
    createBubble: function createBubble(data) {
      var totalData = 0;
      this.notifications.filter(function (notification, index) {
        if (!notification.isClose) {
          totalData++;
        }
      });
      if (totalData >= this.limit) {
        for (var i = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.notifications).length; i >= this.limit; i--) {
          this.closeBubble(i - 1);
        }
      }
      this.notifications.unshift({
        id: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.notifications).length,
        notificationUuid: data.notificationUuid,
        title: data.title,
        body: data.body,
        type: data.type,
        uuid: data.uuid,
        isClose: false,
        isHide: false
      });
    },
    closeBubble: function closeBubble(index) {
      this.notifications[index].isClose = true;
    },
    readNotification: function readNotification(notificationUuid, uuid, type, key) {
      this.afterClickNotification(notificationUuid, uuid, type);
      this.closeBubble(key);
    }
  }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(835);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_index_moduleMenu__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_index_visitorPieChart__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_index_visitorList__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_index_visitorLog__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_index_visitorExceeded__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_index_bookingList__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_index_complaintPieChartByStatus__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_index_complaintPieChartByCategory__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_index_complaintList__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_index_bcmessageList__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_index_panicPieChart__ = __webpack_require__(870);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menuIndex',
  components: {
    ModuleMenu: __WEBPACK_IMPORTED_MODULE_0__views_index_moduleMenu__["a" /* default */],

    VisitorPieChart: __WEBPACK_IMPORTED_MODULE_1__views_index_visitorPieChart__["a" /* default */],
    VisitorList: __WEBPACK_IMPORTED_MODULE_2__views_index_visitorList__["a" /* default */],
    VisitorLog: __WEBPACK_IMPORTED_MODULE_3__views_index_visitorLog__["a" /* default */],
    VisitorExceeded: __WEBPACK_IMPORTED_MODULE_4__views_index_visitorExceeded__["a" /* default */],

    BookingList: __WEBPACK_IMPORTED_MODULE_5__views_index_bookingList__["a" /* default */],

    complaintPieChartByStatus: __WEBPACK_IMPORTED_MODULE_6__views_index_complaintPieChartByStatus__["a" /* default */],
    complaintPieChartByCategory: __WEBPACK_IMPORTED_MODULE_7__views_index_complaintPieChartByCategory__["a" /* default */],
    ComplaintList: __WEBPACK_IMPORTED_MODULE_8__views_index_complaintList__["a" /* default */],

    BcmessageList: __WEBPACK_IMPORTED_MODULE_9__views_index_bcmessageList__["a" /* default */],

    PanicPieChart: __WEBPACK_IMPORTED_MODULE_10__views_index_panicPieChart__["a" /* default */]
  },
  methods: {
    getVisExCount: function getVisExCount(val) {
      var badge = document.getElementById('visExceedBadge');
      if (val > 0) {
        badge.classList.remove('hidden');
      } else {
        badge.classList.add('hidden');
      }
      document.getElementById('visExceedCount').innerHTML = val;
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_charts_HighchartInit__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_components_charts_HighchartInit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__views_components_charts_HighchartInit__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorPieChart',
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      apiPieStatsVisitor: window.AppConfig.apiUrl + 'visitorstats',
      apiUrlStatus: window.AppConfig.apiUrl + 'visitor-status',
      color: {
        'Assigned': {
          'color': '#ffc107'
        },
        'Accepted': {
          'color': '#17a2b8'
        },
        'In Progress': {
          'color': '#3f82b6'
        },
        'Completed': {
          'color': '#28a745'
        }
      },
      pieOptions: {
        day: null,
        week: null,
        month: null
      },
      visitorStatusList: []
    };
  },
  mounted: function mounted() {
    this.getVisitorStats('day');
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refVisitorPie);
  },

  methods: {
    getVisitorStats: function getVisitorStats(period) {
      var dataChart = [{
        name: 'Assigned',
        selected: false,
        sliced: false,
        y: 2
      }, {
        name: 'Accepted',
        selected: false,
        sliced: false,
        y: 10
      }, {
        name: 'In Progress',
        selected: false,
        sliced: false,
        y: 3
      }, {
        name: 'Completed',
        selected: false,
        sliced: false,
        y: 12
      }];
      var opt = __WEBPACK_IMPORTED_MODULE_1__views_components_charts_HighchartInit__["pieOptions"];
      opt.series = [{
        name: 'data',
        data: dataChart
      }];
      opt.colors = [this.color['Assigned'].color, this.color['Accepted'].color, this.color['In Progress'].color, this.color['Completed'].color];
      var self = this;
      opt.plotOptions.pie.point = {
        events: {
          click: function click(e) {
            self.redirectToPage(this.name);
            return false;
          }
        }
      };
      this.pieOptions[period] = opt;
    },
    redirectToPage: function redirectToPage() {
      this.$router.push({ path: '/tickets' });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this = this;

      this.refVisitorPie = setInterval(function () {
        _this.getVisitorStats('day');
      }, window.AppConfig.IntervalRefreshDataDashboard);
    }
  }
});

/***/ }),
/* 340 */,
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorList',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrlGetVisitorList: window.AppConfig.apiUrl + 'visitor?start_date=' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD') + '&end_date=' + __WEBPACK_IMPORTED_MODULE_1_moment___default()().format('YYYY-MM-DD'),
      visitorList: []
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refVisitorList);
  },

  methods: {
    getVisitorStatusColor: function getVisitorStatusColor(val) {
      switch (val) {
        case 'Registered':
          return 'primary';
        case 'Check In':
          return 'success';
        case 'Check Out':
          return 'dark';
        default:
          return 'secondary';
      }
    },
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetVisitorList).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.visitorList = response.data._embedded.visitor;
          for (var i = 0; i < _this.visitorList.length; i++) {
            _this.visitorList[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.visitorList[i]['createdAt']).format('DD HH:mm:ss A');
          }
        } else {
          _this.visitorList = [];
        }
      }).catch(function (error) {
        _this.$refs.progress.deactivateProgressBar();
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refVisitorList = setInterval(function () {
        _this2.getList();
      }, window.AppConfig.IntervalRefreshDataDashboard);
    }
  }

});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorLog',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrlGetVisitorStatusLog: window.AppConfig.apiUrl + 'visitor-status-log?limit=30',
      visitorStatusLog: []
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refVisitorLog);
  },

  methods: {
    setVisitorStatusColor: function setVisitorStatusColor(val) {
      switch (val) {
        case 'Registered':
          return 'fa fa-user-plus bg-primary btn-pill';
        case 'Check In':
          return 'icon-login bg-success btn-pill';
        case 'Check Out':
          return 'icon-logout bg-dark text-white btn-pill';
        default:
          return 'icon-ghost bg-secondary btn-pill';
      }
    },
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetVisitorStatusLog).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.visitorStatusLog = response.data._embedded.visitorStatusLog;
          for (var i = 0; i < _this.visitorStatusLog.length; i++) {
            _this.visitorStatusLog[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.visitorStatusLog[i]['createdAt']).fromNow();
          }
        } else {
          _this.visitorStatusLog = [];
        }
      }).catch(function (error) {
        _this.visitorStatusLog = [];
        _this.$refs.progress.deactivateProgressBar();
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refVisitorLog = setInterval(function () {
        _this2.getList();
      }, window.AppConfig.IntervalRefreshDataDashboard);
    }
  }

});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorExceeded',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  props: {
    method1: null
  },
  data: function data() {
    return {
      apiUrlGetvisitorExceeded: window.AppConfig.apiUrl + 'visitor-exceed-time?order=visitStartTime&ascending=1',
      visitorExceeded: [],
      visitorExceededCount: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refVisitorExceeded);
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetvisitorExceeded).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.visitorExceeded = response.data._embedded.visitorExceedTime;
          for (var i = 0; i < _this.visitorExceeded.length; i++) {
            _this.visitorExceeded[i]['visitStartTime'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.visitorExceeded[i]['visitStartTime']).fromNow();
          }
        } else {
          _this.visitorExceeded = [];
        }
        _this.method1(response.data.total_items);
      }).catch(function (error) {
        _this.$refs.progress.deactivateProgressBar();
        _this.visitorExceeded = [];
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    getVisitorExCount: function getVisitorExCount() {
      return this.visitorExceedCount;
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refVisitorExceeded = setInterval(function () {
        _this2.getList();
      }, window.AppConfig.IntervalRefreshDataDashboard);
    }
  }

});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'facilityBookingList',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrlGetFacilityBookingList: window.AppConfig.apiUrl + 'site-visit',
      facilityBookingList: []
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refFacilityBookingList);
  },

  methods: {
    getFacilityBookingStatusColor: function getFacilityBookingStatusColor(val) {
      switch (val) {
        case 'Requested':
          return 'primary';
        case 'Rejected':
          return 'danger';
        case 'Approved':
          return 'success';
        case 'Check In':
          return 'info';
        case 'Check Out':
          return 'dark';
        case 'Cancelled':
          return 'warning';
        default:
          return 'light';
      }
    },
    setColorStatus: function setColorStatus(value) {},
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetFacilityBookingList).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.facilityBookingList = response.data._embedded.siteVisit;
          for (var i = 0; i < _this.facilityBookingList.length; i++) {
            _this.facilityBookingList[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.facilityBookingList[i]['createdAt']).format('DD HH:mm:ss A');
          }
        } else {
          _this.facilityBookingList = [];
        }
      }).catch(function (error) {
        _this.$refs.progress.deactivateProgressBar();
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    getTimeDesc: function getTimeDesc(data) {
      if (data.startTime !== null) {
        return '<span class="fa fa-calendar"></span> ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.startTime).format('ddd, DD MMM YYYY') + '&nbsp;&nbsp; <span class="fa fa-clock-o"></span> ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.startTime).format('HH:mm:ss');
      } else {
        return '<span class="fa fa-calendar"></span> ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.endTime).format('ddd, DD MMM YYYY') + '&nbsp;&nbsp; <span class="fa fa-clock-o"></span> ' + __WEBPACK_IMPORTED_MODULE_1_moment___default()(data.endTime).format('HH:mm:ss');
      }
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refFacilityBookingList = setInterval(function () {
        _this2.getList();
      }, window.AppConfig.IntervalRefreshData);
    }
  }

});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorPieChart',
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      apiPieStatsComplaint: window.AppConfig.apiUrl + 'complaint-stats',
      apiUrlComplaintStatus: window.AppConfig.apiUrl + 'complain-status',
      complaintStatusList: [],
      color: {
        'Pending': {
          'color': '#ffc107'
        },
        'In Progress': {
          'color': '#20a8d8'
        },
        'Resolved': {
          'color': '#4dbd74'
        }
      },
      pieOptions: null
    };
  },
  mounted: function mounted() {
    try {
      this.getComplaintStats();
      this.doAutoRefresh();
    } catch (err) {
      window.consoleLog(err);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refComplaintPie);
  },

  methods: {
    getComplaintStats: function getComplaintStats() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrlComplaintStatus).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.complainStatus;
          for (var i = 0; i < response.data.total_items; i++) {
            _this.complaintStatusList[datas[i].name] = datas[i].uuid;
          }
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.apiPieStatsComplaint).then(function (response) {
            if (response === undefined) return false;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).length) {
              var tmp = 0;
              for (var key in response.data) {
                tmp += parseInt(response.data[key]);
              }if (tmp !== 0) {
                var dataChart = [];
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (key) {
                  dataChart.push({
                    'name': key,
                    'y': parseInt(response.data[key]),
                    'sliced': dataChart.length === 0,
                    'selected': dataChart.length === 0
                  });
                });
                var opt = __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__["pieOptions"];
                opt.series = [{
                  name: 'data',
                  data: dataChart
                }];
                opt.colors = [];
                var self = _this;
                opt.plotOptions.pie.point = {
                  events: {
                    click: function click(e) {
                      self.redirectToPage(this.name);
                      return false;
                    }
                  }
                };
                for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).length; _i++) {
                  opt.colors.push(_this.color[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data)[_i]].color);
                }
                _this.pieOptions = opt;
              } else {
                _this.pieOptions = null;
              }
            }
          }).catch(function (error) {
            _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
              _this.$alertify.error(errMsg);
            });
          });
        }
      });
    },
    redirectToPage: function redirectToPage(statusName) {
      this.$router.push({ path: '/complaint', query: { 'complain_status_uuid': this.complaintStatusList[statusName] } });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refComplaintPie = setInterval(function () {
        _this2.getComplaintStats();
      }, window.AppConfig.IntervalRefreshData);
    }
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visitorPieChart',
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_1_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      apiPieStatsComplaint: window.AppConfig.apiUrl + 'complaint-stats.category',
      apiUrlComplaintCategory: window.AppConfig.apiUrl + 'complain-category',
      complaintCategoryList: [],
      pieOptions: null,
      colors: ['#ffc107', '#20a8d8', '#4dbd74', '#DBCE51', '#16B582', '#21C273', '#44B167', '#E9BE46', '#497D65', '#4D421E', '#48D422', '#81C1A5', '#FA3150', '#34946E', '#F28E35', '#5E2E51', '#3D50A6', '#A4C6CC', '#7B5235', '#C455AE', '#D10DAD', '#7E9A78', '#583A49', '#F5DB2E', '#FCE797', '#3C2BCC', '#D28563', '#ABB53B', '#2A72E7', '#B59438', '#A52276', '#157055', '#056F34', '#341766', '#52AEEB', '#C9CEA3', '#B6AB24', '#89969C', '#D98151', '#9B3C1B', '#77387B', '#5E936A', '#38653B', '#3D5982', '#003F53', '#851559', '#EE8163', '#12A785', '#B5F358', '#19664D', '#FEF5BB', '#6DE597', '#17CF34', '#D182C6', '#BB2CD7', '#515762', '#BF4293', '#AE7242', '#B4E7E7', '#2B4AAA', '#2FC13F', '#37BBCD', '#3B3BCB', '#6EF7BA', '#626605', '#E9ABAC', '#8D36D5', '#DB2202', '#E423D5', '#61BC5C', '#57613E', '#923D28', '#39C383', '#B5601D', '#1A3C61', '#347507', '#12DD27', '#E5443A', '#B43C4C', '#66FD29', '#1E1538', '#4697E8', '#0BF51A', '#C262FF', '#A62237', '#98D1BF', '#1ADAAC', '#42FBC1', '#585AA0', '#563515', '#E8BADC', '#A3B65E', '#B39E4D', '#25E544', '#6EEC8B', '#D99982', '#139FBA', '#0F6744', '#718A1C', '#4EE119', '#C9C813', '#FBF3B5', '#9E6A71']
    };
  },
  mounted: function mounted() {
    try {
      this.getComplaintStats();
      this.doAutoRefresh();
    } catch (err) {
      window.consoleLog(err);
    }
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refComplaintPie);
  },

  methods: {
    getComplaintStats: function getComplaintStats() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.apiUrlComplaintCategory).then(function (response) {
        if (response !== undefined) {
          var datas = response.data._embedded.complainCategory;
          for (var i = 0; i < response.data.total_items; i++) {
            _this.complaintCategoryList[datas[i].name] = datas[i].uuid;
          }
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(_this.apiPieStatsComplaint).then(function (response) {
            if (response === undefined) return false;
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).length) {
              var tmp = 0;
              for (var key in response.data) {
                tmp += parseInt(response.data[key]);
              }if (tmp !== 0) {
                var dataChart = [];
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).forEach(function (key) {
                  dataChart.push({
                    'name': key,
                    'y': parseInt(response.data[key]),
                    'sliced': dataChart.length === 0,
                    'selected': dataChart.length === 0
                  });
                });
                var opt = __WEBPACK_IMPORTED_MODULE_2__views_components_charts_HighchartInit__["pieOptions"];
                opt.series = [{
                  name: 'data',
                  data: dataChart
                }];

                var self = _this;
                opt.plotOptions.pie.point = {
                  events: {
                    click: function click(e) {
                      self.redirectToPage(this.name);
                      return false;
                    }
                  }
                };
                for (var _i = 0; _i < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data).length; _i++) {
                  opt.colors.push(_this.colors[_i]);
                }
                _this.pieOptions = opt;
              } else {
                _this.pieOptions = null;
              }
            }
          }).catch(function (error) {
            _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
              _this.$alertify.error(errMsg);
            });
          });
        }
      });
    },
    redirectToPage: function redirectToPage(categoryName) {
      this.$router.push({ path: '/complaint', query: { 'complain_category_uuid': this.complaintCategoryList[categoryName] } });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refComplaintPie = setInterval(function () {
        _this2.getComplaintStats();
      }, window.AppConfig.IntervalRefreshData);
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'complaintList',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrlGetComplaintList: window.AppConfig.apiUrl + 'complain?limit=10',
      complaintList: []
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refComplaintList);
  },

  methods: {
    getComplaintStatusColor: function getComplaintStatusColor(val) {
      switch (val) {
        case 'Pending':
          return 'warning';
        case 'In Progress':
          return 'primary';
        case 'Resolved':
          return 'success';
        default:
          return 'danger';
      }
    },
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrlGetComplaintList).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.complaintList = response.data._embedded.complain;
          for (var i = 0; i < _this.complaintList.length; i++) {
            _this.complaintList[i]['createdAt'] = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_this.complaintList[i]['createdAt']).format('DD HH:mm:ss A');
          }
        } else {
          _this.complaintList = [];
        }
      }).catch(function (error) {
        _this.$refs.progress.deactivateProgressBar();
        _this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this.$alertify.error(errMsg);
        });
      });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this2 = this;

      this.refComplaintList = setInterval(function () {
        _this2.getList();
      }, window.AppConfig.IntervalRefreshData);
    }
  }

});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__ = __webpack_require__(13);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BroadcastMessageList',
  components: {
    progressLoader: __WEBPACK_IMPORTED_MODULE_2__views_components_progressLoader__["a" /* default */]
  },
  data: function data() {
    return {
      apiUrl: window.AppConfig.apiUrl + 'broadcast-message?limit=10&ascending=0',
      tableItems: []
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      try {
        self.getList();
      } catch (err) {
        self.getList();
      }
      self.doAutoRefresh();
    }, Math.floor(Math.random() * 1200) + 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refBcMessage);
  },

  methods: {
    getList: function getList() {
      var _this = this;

      this.$refs.progress.activateProgressBar();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiUrl).then(function (response) {
        if (response === undefined) return false;
        _this.$refs.progress.deactivateProgressBar();
        if (response !== undefined) {
          _this.tableItems = response.data._embedded.broadcastMessage;
        } else {
          _this.tableItems = [];
        }
      }).catch(function (error) {
        var _this2 = this;

        this.$store.dispatch('errorMessage', error).then(function (errMsg) {
          _this2.$alertify.error(errMsg);
        });
      });
    },
    getDateFormat: function getDateFormat(value) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).fromNow();
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this3 = this;

      this.refBcMessage = setInterval(function () {
        _this3.getList();
      }, window.AppConfig.IntervalRefreshDataDashboard);
    },
    statusMessage: function statusMessage(t) {
      return !t.isPublished ? '<span class="fa fa-text"></span> <em>[Draft]</em>' : '<span class="fa fa-clock-o"></span> Published at ' + this.getDateFormat(t.publishedAt);
    }
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_highcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_highcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_highcharts__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'panicPieChart',
  components: {
    VueHighcharts: __WEBPACK_IMPORTED_MODULE_0_vue2_highcharts___default.a
  },
  data: function data() {
    return {
      apiPieStatsVisitor: window.AppConfig.apiUrl + 'visitorstats',
      apiUrlStatus: window.AppConfig.apiUrl + 'visitor-status',
      color: {
        'Out Site': {
          'color': '#6c757d'
        },
        'At Site': {
          'color': '#3f82b6'
        }
      },
      pieOptions: {
        day: null,
        week: null,
        month: null
      },
      visitorStatusList: []
    };
  },
  mounted: function mounted() {
    this.getVisitorStats('day');
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.refVisitorPie);
  },

  methods: {
    getVisitorStats: function getVisitorStats(period) {
      var dataChart = [{
        name: 'Out Site',
        selected: false,
        sliced: false,
        y: 2
      }, {
        name: 'At Site',
        selected: false,
        sliced: false,
        y: 10
      }];
      var opt = {
        chart: {
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          height: 300
        },
        title: {
          text: ''
        },
        series: [{
          name: 'data',
          data: []
        }],
        colors: [],
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y}</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 10,
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y}',
              distance: -30,
              style: {
                color: __WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.theme && __WEBPACK_IMPORTED_MODULE_1_highcharts___default.a.theme.contrastTextColor || 'black'
              }
            },
            size: '80%'
          }
        },
        noData: {
          attr: 'no Item display',
          position: {
            align: 'center',
            verticalAlign: 'middle',
            x: 0,
            y: 0
          }
        },
        credits: {
          enabled: false
        }
      };
      opt.series = [{
        name: 'data',
        data: dataChart
      }];
      opt.colors = [this.color['Out Site'].color, this.color['At Site'].color];
      var self = this;
      opt.plotOptions.pie.point = {
        events: {
          click: function click(e) {
            self.redirectToPage(this.name);
            return false;
          }
        }
      };
      this.pieOptions[period] = opt;
    },
    redirectToPage: function redirectToPage() {
      this.$router.push({ path: '/visited-sites' });
    },
    doAutoRefresh: function doAutoRefresh() {
      var _this = this;

      this.refVisitorPie = setInterval(function () {
        _this.getVisitorStats('day');
      }, window.AppConfig.IntervalRefreshDataDashboard);
    }
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Page404'
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    linkActive: function linkActive(name) {
      return this.$route.path.indexOf(name) > -1;
    }
  }
});

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _bootstrapVue = __webpack_require__(363);

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _App = __webpack_require__(513);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(133);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(879);

var _store2 = _interopRequireDefault(_store);

var _vueAlertify = __webpack_require__(896);

var _vueAlertify2 = _interopRequireDefault(_vueAlertify);

var _vueSelect = __webpack_require__(898);

var _vueSelect2 = _interopRequireDefault(_vueSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.component('v-select', _vueSelect2.default);
_vue2.default.use(_vueAlertify2.default);


try {
  __webpack_require__(899);
  __webpack_require__(901);

  _router2.default.beforeEach(function (to, from, next) {
    if (to.matched.some(function (record) {
      return record.meta.requiresAuth;
    })) {
      if (!_store2.default.getters.isLoggedIn) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    } else if (to.matched.some(function (record) {
      return record.meta.requiresGuest;
    })) {
      if (_store2.default.getters.isLoggedIn) {
        next({
          path: '/',
          query: { redirect: to.fullPath }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  });
  if (_store2.default.getters.isLoggedIn) {
    _store2.default.dispatch('saveTokens', { tokens: _store2.default.getters.accessTokens, accountData: null, isLocalLogin: true });
  }

  _vue2.default.use(_bootstrapVue2.default);

  _vue2.default.config.productionTip = false;

  new _vue2.default({
    el: '#app',
    router: _router2.default,
    store: _store2.default,
    template: '<App/>',
    components: {
      App: _App2.default
    }
  });
} catch (ex) {
  alert('Can\'t find config file !!!');
}

/***/ }),
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(132);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfce43ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(516);
function injectStyle (ssrContext) {
  __webpack_require__(514)
  __webpack_require__(515)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfce43ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */,
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(134);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18a6ad2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f18a6ad2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f18a6ad2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center bg-login"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[(_vm.isLoading)?_c('b-progress',{attrs:{"value":100,"max":100,"animated":""}}):_vm._e(),_vm._v(" "),_c('b-card-group',{staticClass:"box-shadow"},[_c('b-card',{staticClass:"text pt-4 pb-0",attrs:{"no-body":""}},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":"/static/img/logo-iwk.png","alt":""}}),_vm._v(" "),_c('b-card-body',[_c('form',{staticClass:"app-login-box",attrs:{"method":"POST","autocomplete":""},on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Login")]),_vm._v(" "),(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.username.value),expression:"user.username.value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Username","id":"username","required":""},domProps:{"value":(_vm.user.username.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.username, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.user.username.error !== null)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.user.username.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-4"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-lock"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password.value),expression:"user.password.value"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","id":"password","required":""},domProps:{"value":(_vm.user.password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.password, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.user.password.error !== null)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.user.password.error))]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"px-4 btn-block pull-right",staticStyle:{"border-radius":"3px"},attrs:{"type":"submit","variant":"primary","disabled":_vm.isLoading}},[_vm._v("\n                      Login\n                      ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"text-muted px-0",attrs:{"to":"/forgot-password","variant":"link"}},[_vm._v("Forgot password?")])],1)],1)],1)])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(137);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eece4d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eece4d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eece4d4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(138);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d6714d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(549);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30d6714d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d6714d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center bg-login"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[(_vm.isLoading)?_c('b-progress',{attrs:{"value":100,"max":100,"animated":""}}):_vm._e(),_vm._v(" "),_c('b-card-group',{staticClass:"box-shadow"},[_c('b-card',{staticClass:"text pt-4 pb-0",attrs:{"no-body":""}},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":"/static/img/logo-iwk.png","alt":""}}),_vm._v(" "),_c('b-card-body',[_c('form',{staticClass:"app-login-box",attrs:{"method":"POST","autocomplete":""},on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"8px"}},[_vm._v("Forgot Password")]),_vm._v(" "),(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.emailAddress.value),expression:"user.emailAddress.value"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email","id":"username","required":""},domProps:{"value":(_vm.user.emailAddress.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.emailAddress, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.user.emailAddress.error !== null)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.user.emailAddress.error))]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"px-4 btn-block pull-right",staticStyle:{"border-radius":"3px"},attrs:{"type":"submit","variant":"primary","disabled":_vm.isLoading}},[_vm._v("\n                      Reset Password\n                      ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"text-align":"right"},attrs:{"md":"12","lg":"12"}},[_c('b-button',{staticClass:"text-muted px-0",attrs:{"to":"/login","variant":"link"}},[_vm._v("back to log in")])],1)],1)],1)])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(144);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ebe1c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(552);
function injectStyle (ssrContext) {
  __webpack_require__(551)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58ebe1c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ebe1c6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center bg-login"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"4"}},[_c('b-card-group',{staticClass:"box-shadow"},[_c('b-card',{staticClass:"text pt-4 pb-0",attrs:{"no-body":""}},[_c('img',{staticStyle:{"margin":"auto"},attrs:{"src":"/static/img/logo-iwk.png","alt":""}}),_vm._v(" "),_c('b-card-body',[_c('form',{staticClass:"app-login-box",attrs:{"method":"POST","autocomplete":""},on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"8px"}},[_vm._v("Forgot Password")]),_vm._v(" "),_c('p',{staticClass:"text-white"},[_vm._v("Please create your New Password")]),_vm._v(" "),(_vm.successMsg !== null)?_c('div',{staticClass:"alert alert-success"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.successMsg)}})]):_vm._e(),_vm._v(" "),(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password.value),expression:"user.password.value"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"New Password","id":"password","required":""},domProps:{"value":(_vm.user.password.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.password, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.user.password.error !== null)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.user.password.error))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group mb-3"},[_c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"icon-user"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.passwordConfirmation.value),expression:"user.passwordConfirmation.value"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password Confirmation","id":"passwordConfirmation","required":""},domProps:{"value":(_vm.user.passwordConfirmation.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user.passwordConfirmation, "value", $event.target.value)}}})]),_vm._v(" "),(_vm.user.passwordConfirmation.error !== null)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.user.passwordConfirmation.error))]):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"text-muted px-0",attrs:{"to":"/login","variant":"link"}},[_vm._v("Back to Log In")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4 pull-right",attrs:{"type":"submit","variant":"primary","disabled":_vm.isLoading}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}):_vm._e(),_vm._v(" Change Password\n                      ")])],1)],1)],1)])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(145);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67aa33be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(554);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67aa33be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$route.name === 'User Profile')?_c('b-card',{attrs:{"title":'User Profile',"sub-title":""}},[_c('b-col',{attrs:{"lg":"12"}},[_c('b-form-row',{staticClass:"form-detail"},[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"label":"Email","label-for":"email","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.email))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"First Name","label-for":"firstName","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.firstName))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Last Name","label-for":"lastName","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.lastName))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","label-for":"phone","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.phone !== null ? _vm.$store.getters.accountData.phone : '-'))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Mobile","label-for":"mobile","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.mobile !== null ? _vm.$store.getters.accountData.mobile : '-'))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Account","label-for":"account","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.account.name))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Timezone","label-for":"timezone","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.$store.getters.accountData.account.timezone))])])],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"href":"#/profile/password","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-cog"}),_vm._v(" Change Password\n          ")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(146);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125925a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(567);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_125925a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('b-progress',{class:_vm.getClass(),style:(_vm.customStyle),attrs:{"value":_vm.counter,"max":_vm.max,"animated":""}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)},"reset":_vm.setEmptyForm}},[_c('b-card',{attrs:{"title":"Change Password","sub-title":""}},[_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('b-form-group',{attrs:{"label":"Current Password","label-for":"currentPassword","label-class":"font-weight-bold","label-cols":"5","horizontal":true}},[_c('b-form-input',{attrs:{"id":"currentPassword","type":"password"},model:{value:(_vm.account.currentPassword.value),callback:function ($$v) {_vm.$set(_vm.account.currentPassword, "value", $$v)},expression:"account.currentPassword.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.account.currentPassword.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.account.currentPassword.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"New Password","label-for":"newPassword","label-class":"font-weight-bold","label-cols":"5","horizontal":true}},[_c('b-form-input',{attrs:{"id":"newPassword","type":"password"},model:{value:(_vm.account.newPassword.value),callback:function ($$v) {_vm.$set(_vm.account.newPassword, "value", $$v)},expression:"account.newPassword.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.account.newPassword.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.account.newPassword.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Confirm Password","label-for":"confirmPassword","label-class":"font-weight-bold","label-cols":"5","horizontal":true}},[_c('b-form-input',{attrs:{"id":"confirmPassword","type":"password"},model:{value:(_vm.account.confirmPassword.value),callback:function ($$v) {_vm.$set(_vm.account.confirmPassword, "value", $$v)},expression:"account.confirmPassword.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.account.confirmPassword.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.account.confirmPassword.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","href":"#/profile","variant":"light"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"type":"reset","size":"md","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Reset\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"type":"submit","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Submit\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(153);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b9023e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(746);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b9023e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 180,
	"./af.js": 180,
	"./ar": 181,
	"./ar-dz": 182,
	"./ar-dz.js": 182,
	"./ar-kw": 183,
	"./ar-kw.js": 183,
	"./ar-ly": 184,
	"./ar-ly.js": 184,
	"./ar-ma": 185,
	"./ar-ma.js": 185,
	"./ar-sa": 186,
	"./ar-sa.js": 186,
	"./ar-tn": 187,
	"./ar-tn.js": 187,
	"./ar.js": 181,
	"./az": 188,
	"./az.js": 188,
	"./be": 189,
	"./be.js": 189,
	"./bg": 190,
	"./bg.js": 190,
	"./bn": 191,
	"./bn.js": 191,
	"./bo": 192,
	"./bo.js": 192,
	"./br": 193,
	"./br.js": 193,
	"./bs": 194,
	"./bs.js": 194,
	"./ca": 195,
	"./ca.js": 195,
	"./cs": 196,
	"./cs.js": 196,
	"./cv": 197,
	"./cv.js": 197,
	"./cy": 198,
	"./cy.js": 198,
	"./da": 199,
	"./da.js": 199,
	"./de": 200,
	"./de-at": 201,
	"./de-at.js": 201,
	"./de-ch": 202,
	"./de-ch.js": 202,
	"./de.js": 200,
	"./dv": 203,
	"./dv.js": 203,
	"./el": 204,
	"./el.js": 204,
	"./en-au": 205,
	"./en-au.js": 205,
	"./en-ca": 206,
	"./en-ca.js": 206,
	"./en-gb": 207,
	"./en-gb.js": 207,
	"./en-ie": 208,
	"./en-ie.js": 208,
	"./en-nz": 209,
	"./en-nz.js": 209,
	"./eo": 210,
	"./eo.js": 210,
	"./es": 211,
	"./es-do": 212,
	"./es-do.js": 212,
	"./es.js": 211,
	"./et": 213,
	"./et.js": 213,
	"./eu": 214,
	"./eu.js": 214,
	"./fa": 215,
	"./fa.js": 215,
	"./fi": 216,
	"./fi.js": 216,
	"./fo": 217,
	"./fo.js": 217,
	"./fr": 218,
	"./fr-ca": 219,
	"./fr-ca.js": 219,
	"./fr-ch": 220,
	"./fr-ch.js": 220,
	"./fr.js": 218,
	"./fy": 221,
	"./fy.js": 221,
	"./gd": 222,
	"./gd.js": 222,
	"./gl": 223,
	"./gl.js": 223,
	"./gom-latn": 224,
	"./gom-latn.js": 224,
	"./he": 225,
	"./he.js": 225,
	"./hi": 226,
	"./hi.js": 226,
	"./hr": 227,
	"./hr.js": 227,
	"./hu": 228,
	"./hu.js": 228,
	"./hy-am": 229,
	"./hy-am.js": 229,
	"./id": 230,
	"./id.js": 230,
	"./is": 231,
	"./is.js": 231,
	"./it": 232,
	"./it.js": 232,
	"./ja": 233,
	"./ja.js": 233,
	"./jv": 234,
	"./jv.js": 234,
	"./ka": 235,
	"./ka.js": 235,
	"./kk": 236,
	"./kk.js": 236,
	"./km": 237,
	"./km.js": 237,
	"./kn": 238,
	"./kn.js": 238,
	"./ko": 239,
	"./ko.js": 239,
	"./ky": 240,
	"./ky.js": 240,
	"./lb": 241,
	"./lb.js": 241,
	"./lo": 242,
	"./lo.js": 242,
	"./lt": 243,
	"./lt.js": 243,
	"./lv": 244,
	"./lv.js": 244,
	"./me": 245,
	"./me.js": 245,
	"./mi": 246,
	"./mi.js": 246,
	"./mk": 247,
	"./mk.js": 247,
	"./ml": 248,
	"./ml.js": 248,
	"./mr": 249,
	"./mr.js": 249,
	"./ms": 250,
	"./ms-my": 251,
	"./ms-my.js": 251,
	"./ms.js": 250,
	"./my": 252,
	"./my.js": 252,
	"./nb": 253,
	"./nb.js": 253,
	"./ne": 254,
	"./ne.js": 254,
	"./nl": 255,
	"./nl-be": 256,
	"./nl-be.js": 256,
	"./nl.js": 255,
	"./nn": 257,
	"./nn.js": 257,
	"./pa-in": 258,
	"./pa-in.js": 258,
	"./pl": 259,
	"./pl.js": 259,
	"./pt": 260,
	"./pt-br": 261,
	"./pt-br.js": 261,
	"./pt.js": 260,
	"./ro": 262,
	"./ro.js": 262,
	"./ru": 263,
	"./ru.js": 263,
	"./sd": 264,
	"./sd.js": 264,
	"./se": 265,
	"./se.js": 265,
	"./si": 266,
	"./si.js": 266,
	"./sk": 267,
	"./sk.js": 267,
	"./sl": 268,
	"./sl.js": 268,
	"./sq": 269,
	"./sq.js": 269,
	"./sr": 270,
	"./sr-cyrl": 271,
	"./sr-cyrl.js": 271,
	"./sr.js": 270,
	"./ss": 272,
	"./ss.js": 272,
	"./sv": 273,
	"./sv.js": 273,
	"./sw": 274,
	"./sw.js": 274,
	"./ta": 275,
	"./ta.js": 275,
	"./te": 276,
	"./te.js": 276,
	"./tet": 277,
	"./tet.js": 277,
	"./th": 278,
	"./th.js": 278,
	"./tl-ph": 279,
	"./tl-ph.js": 279,
	"./tlh": 280,
	"./tlh.js": 280,
	"./tr": 281,
	"./tr.js": 281,
	"./tzl": 282,
	"./tzl.js": 282,
	"./tzm": 283,
	"./tzm-latn": 284,
	"./tzm-latn.js": 284,
	"./tzm.js": 283,
	"./uk": 285,
	"./uk.js": 285,
	"./ur": 286,
	"./ur.js": 286,
	"./uz": 287,
	"./uz-latn": 288,
	"./uz-latn.js": 288,
	"./uz.js": 287,
	"./vi": 289,
	"./vi.js": 289,
	"./x-pseudo": 290,
	"./x-pseudo.js": 290,
	"./yo": 291,
	"./yo.js": 291,
	"./zh-cn": 292,
	"./zh-cn.js": 292,
	"./zh-hk": 293,
	"./zh-hk.js": 293,
	"./zh-tw": 294,
	"./zh-tw.js": 294
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('v-server-table',{ref:"dataTable",attrs:{"id":"list-table","url":_vm.url,"columns":_vm.columns,"options":_vm.options},on:{"loading":_vm.onTableLoading,"loaded":_vm.onTableLoaded,"pagination":_vm.onPagination},scopedSlots:_vm._u([{key:"actionButtons",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":_vm.getUrlDetail(props.row.uuid),"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"primary","href":_vm.getUrlDetail(props.row.uuid) + '/edit',"title":"Edit"}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"danger","title":"Remove"},on:{"click":function($event){_vm.doRemove(props.row.uuid)}}},[_c('i',{staticClass:"fa fa-times"})])],1)]}},{key:"securityCheckSeriesSchedule",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[_vm._v("\n        "+_vm._s(props.row.securityCheckSeriesSchedule === null ? '-' : props.row.securityCheckSeriesSchedule)+"\n      ")])]}},{key:"billingDetailButton",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/billing/' + props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtonLocationGroup",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"primary","href":_vm.getUrlDetail(props.row.uuid) + '/edit',"title":"Edit"}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"danger","title":"Remove"},on:{"click":function($event){_vm.doRemove(props.row.uuid)}}},[_c('i',{staticClass:"fa fa-times"})])],1)]}},{key:"actionButtons2",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":_vm.getUrlDetail(props.row.uuid),"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"danger","title":"Remove"},on:{"click":function($event){_vm.doRemove(props.row.uuid)}}},[_c('i',{staticClass:"fa fa-times"})])],1)]}},{key:"locationSecurityChecking",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('a',{attrs:{"href":'/#/settings/locations/' + props.row.location.uuid,"title":"Details"}},[_vm._v(_vm._s(props.row.location.name))])])]}},{key:"actionButtons3",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":_vm.getUrlDetail(props.row.uuid),"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtonsVisitorTenant3",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/visitor/'+props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtonsComplaintTenant3",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/complaint/'+props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtonsRequestTenant3",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/request/'+props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtonsBookingTenant3",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/facility-booking/'+props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionDetailComplaint",fn:function(props){return [_c('div',{staticClass:"nowrap"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'/#/reports/complaint-resolved/' + props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtons_bc",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":_vm.getUrlDetail(props.row.uuid),"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})]),_vm._v(" "),(!props.row.isPublished)?_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"primary","href":_vm.getUrlDetail(props.row.uuid) + '/edit',"title":"Edit"}},[_c('i',{staticClass:"fa fa-pencil"})]):_vm._e(),_vm._v(" "),(!props.row.isPublished)?_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"danger","title":"Remove"},on:{"click":function($event){_vm.doRemove(props.row.uuid)}}},[_c('i',{staticClass:"fa fa-times"})]):_vm._e()],1)]}},{key:"actionButtons_scr",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'#/security-checking/' + props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtons_setComplete",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[(props.row.securityCheckingStatus !== 'Completed')?_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"success","title":"Set Completed"},on:{"click":function($event){_vm.method_3(props.row)}}},[_c('i',{staticClass:"fa fa-check text-white"})]):_vm._e()],1)]}},{key:"actionButtons_scncr",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'#/reports/security-checking-not-complate/' + props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"actionButtons_sco",fn:function(props){return [_c('div',{staticClass:"nowrap text-center"},[_c('b-button',{staticClass:"btn-rounded",attrs:{"size":"sm","variant":"info","href":'#/reports/security-checking-overtime/' + props.row.uuid,"title":"Details"}},[_c('i',{staticClass:"fa fa-info text-white"})])],1)]}},{key:"securityCheckingStatus",fn:function(props){return [_c('div',{},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.securityCheckingStatus)}},[_vm._v(_vm._s(props.row.securityCheckingStatus))])],1)]}},{key:"taskStatus",fn:function(props){return [_c('div',{},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.taskStatus)}},[_vm._v(_vm._s(props.row.taskStatus))])],1)]}},{key:"highlight",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_3(props.row.timeSpentMinutes, props.row.securityCheckSeries.cycle)}})],1)]}},{key:"panicAlertStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.panicAlertStatus)}},[_vm._v(_vm._s(props.row.panicAlertStatus))])],1)]}},{key:"retributionStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.retributionStatus)}},[_vm._v(_vm._s(props.row.retributionStatus))])],1)]}},{key:"isCheckingRequired",fn:function(props){return [(props.row.isCheckingRequired === true)?_c('div',[_c('b-badge',{staticClass:"badge badge-pill badge-success"},[_vm._v("Yes")])],1):(props.row.isCheckingRequired === false)?_c('div',[_c('b-badge',{staticClass:"badge badge-pill badge-danger"},[_vm._v("No")])],1):_vm._e()]}},{key:"isAvailable",fn:function(props){return [(props.row.isAvailable === 1)?_c('div',[_c('b-badge',{staticClass:"badge badge-pill badge-success"},[_vm._v("Yes")])],1):(props.row.isAvailable === 0)?_c('div',[_c('b-badge',{staticClass:"badge badge-pill badge-danger"},[_vm._v("No")])],1):_vm._e()]}},{key:"isAvailableOnHoliday",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":(props.row.isAvailableOnHoliday ? 'primary' : 'secondary')}},[_vm._v(_vm._s((props.row.isAvailableOnHoliday ? 'Available' : 'Unavailable')))])],1)]}},{key:"facilityBookingStatus",fn:function(props){return [_c('div',[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.facilityBookingStatus)}},[_vm._v(_vm._s(props.row.facilityBookingStatus))]),_vm._v(" "),(props.row.facilityBookingStatus === 'Requested')?[_c('b-btn',{attrs:{"variant":"link","size":"sm","id":'popover-' + props.row.uuid.substring(0, 8)}},[_c('i',{staticClass:"fa fa-chevron-down"})]),_vm._v(" "),_c('b-popover',{attrs:{"target":'popover-' + props.row.uuid.substring(0, 8),"placement":"bottomleft","title":"Approval Booking","triggers":"focus"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"sm","variant":"danger"},on:{"click":function($event){_vm.method_3(props.row)}}},[_c('i',{staticClass:"fa fa-times-circle"}),_vm._v(" Reject")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.method_2(props.row, 'Approved')}}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" Accept")])],1)]:_vm._e()],2)]}},{key:"requestStatus",fn:function(props){return [_c('div',[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.requestStatus)}},[_vm._v(_vm._s(props.row.requestStatus))]),_vm._v(" "),(props.row.requestStatus === 'Pending')?[_c('b-btn',{attrs:{"variant":"link","size":"sm","id":'popover-' + props.row.uuid.substring(0, 8)}},[_c('i',{staticClass:"fa fa-chevron-down"})]),_vm._v(" "),_c('b-popover',{attrs:{"target":'popover-' + props.row.uuid.substring(0, 8),"placement":"bottomleft","title":"Approval Request","triggers":"focus"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"sm","variant":"success"},on:{"click":function($event){_vm.method_2(props.row, 'In Progress')}}},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" Accept")])],1)]:_vm._e()],2)]}},{key:"isActiveStatusHistory",fn:function(props){return [_c('b-badge',{attrs:{"variant":props.row.isActive == 1 ? 'success' : 'secondary'}},[_vm._v(_vm._s(props.row.isActive == 1 ? 'Activated' : 'Deactivated'))])]}},{key:"isActive",fn:function(props){return [_c('span',{on:{"click":function($event){$event.preventDefault();_vm.method_1(props.row)}}},[_c('toggle-button',{attrs:{"value":props.row.isActive == 1,"color":"#3E975D","width":60,"sync":true,"labels":{checked: 'Active', unchecked: 'Non Active'}}})],1)]}},{key:"visitorStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.visitorStatus)}},[_vm._v(_vm._s(props.row.visitorStatus))])],1)]}},{key:"typeText",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_2(props.row.visitorType)}},[_vm._v(_vm._s(props.row.visitorType))])],1)]}},{key:"complainStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.complainStatus)}},[_vm._v(_vm._s(props.row.complainStatus))])],1)]}},{key:"isPublished",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.isPublished)}},[_vm._v(_vm._s(props.row.isPublished ? 'Published' : 'Draft'))])],1)]}},{key:"walkInGuest",fn:function(props){return [(props.row.visitorFlag === 'Walk In')?_c('i',{staticClass:"fa fa-check text-success",attrs:{"aria-hidden":"true","title":"Walk In Guest"}}):_vm._e()]}},{key:"billingMultiPaymentChecbox",fn:function(props){return [_c('div',[(props.row.billingStatus === 'New')?_c('b-form-checkbox',{staticClass:"make-payment-now",attrs:{"button-variant":"success","value":props.row.uuid,"aria-describedby":"Pay","aria-controls":"Pay"},on:{"change":function($event){_vm.addIdMultiPayment(props.row.uuid)}}}):_vm._e()],1)]}},{key:"billingCycle",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.billingCycle)}},[_vm._v(_vm._s(props.row.billingCycle))])],1)]}},{key:"billingFlag",fn:function(props){return [(props.row.billingStatus === 'Paid')?_c('div',{staticClass:"text-center"},[_c('b-btn',{staticClass:"flag",attrs:{"variant":_vm.method_2(props.row.billingFlag),"id":'popover-' + props.row.uuid.substring(0, 8)}},[_vm._v(" ")]),_vm._v(" "),_c('b-popover',{attrs:{"target":'popover-' + props.row.uuid.substring(0, 8),"title":!props.row.billingFlag ? 'Flag this transaction with:' : 'Flagged with:',"placement":"right","triggers":"hover focus"}},[(!props.row.billingFlag)?_c('b-button',{staticClass:"btn-pill",attrs:{"size":"sm","variant":"warning"},on:{"click":function($event){_vm.method_4(props.row, 'Dispute')}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Dispute")]):_c('b-badge',{attrs:{"variant":"warning"}},[_vm._v("Dispute")])],1)],1):(props.row.billingFlag === 'Overdue')?_c('div',{staticClass:"text-center"},[_c('b-badge',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.getOverTime(props.row.dueDate)),expression:"getOverTime(props.row.dueDate)",modifiers:{"hover":true}}],staticClass:"flag",attrs:{"title":props.row.billingFlag + ' !',"variant":_vm.method_2(props.row.billingFlag)}},[_vm._v(" ")])],1):_vm._e()]}},{key:"billingStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_3(props.row.billingStatus)}},[_vm._v(_vm._s(props.row.billingStatus))])],1)]}},{key:"requestChargeStatus",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":_vm.method_1(props.row.requestChargeStatus)}},[_vm._v(_vm._s(props.row.requestChargeStatus))])],1)]}},{key:"visitorOvertime",fn:function(props){return [_c('div',{staticClass:"text-center"},[_c('b-badge',{attrs:{"variant":"danger"}},[_vm._v("overtime")])],1)]}},{key:"logo",fn:function(props){return [_c('img',{attrs:{"src":props.row.paymentMethod.logo,"alt":""}})]}},{key:"paymentUrl",fn:function(props){return [(props.row.paymentMethod.paymentUrl !== null)?_c('div',{staticClass:"nowrap text-center"},[_c('router-link',{attrs:{"to":props.row.paymentMethod.paymentUrl}},[_vm._v("Link")])],1):_c('div',[_vm._v("-")])]}},{key:"namePayment",fn:function(props){return [_vm._v("\n      "+_vm._s(props.row.paymentMethod.name)+"\n    ")]}}])},[_c('template',{slot:"h__billingFlag"},[_c('i',{staticClass:"fa fa-flag text-dark",staticStyle:{"font-size":"15px"}})]),_vm._v(" "),_c('template',{slot:"h__walkInGuest"},[_c('i',{staticClass:"fa fa-users text-dark ",staticStyle:{"font-size":"15px"},attrs:{"title":"Walk In Guest"}})]),_vm._v(" "),_c('template',{slot:"h__paymentMethod"},[_c('b',[_vm._v("Payment "),_c('br'),_vm._v("Method")])]),_vm._v(" "),_c('template',{slot:"h__billingMultiPaymentChecbox"},[_c('i',{staticClass:"fa fa-credit-card text-dark",staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){_vm.toggleCheckbox('make-payment-now', 'paymentIds')}}})])],2),_vm._v(" "),_c('b-button',{staticClass:"multi-payment btn-pill",class:{ 'show-me': _vm.paymentIds.length },attrs:{"size":"lg","variant":"success"},on:{"click":_vm.makeMultiplePayment}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Pay")]),_vm._v(" "),_c('b-modal',{ref:"makePayment",attrs:{"hide-footer":"","title":"Make Multiple Payment"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.doMultiplePayment($event)}}},[_c('b-alert',{attrs:{"show":_vm.makePaymentDialog.hasError,"variant":"danger"}},[_c('i',{staticClass:"fa fa-exclamation",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.makePaymentDialog.hasError)+"\n      ")]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Method","label-for":"method","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-select',{attrs:{"options":[
          { value: 'Cash', text: 'Cash' },
          { value: 'Credit Card', text: 'Credit Card' },
          { value: 'Cheque', text: 'Cheque' } ]},model:{value:(_vm.makePaymentDialog.paymentMethod),callback:function ($$v) {_vm.$set(_vm.makePaymentDialog, "paymentMethod", $$v)},expression:"makePaymentDialog.paymentMethod"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Note","label-for":"note","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-textarea',{attrs:{"id":"note","placeholder":"","rows":1,"max-rows":6},model:{value:(_vm.makePaymentDialog.note),callback:function ($$v) {_vm.$set(_vm.makePaymentDialog, "note", $$v)},expression:"makePaymentDialog.note"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")])],1),_vm._v(" "),_c('b-button',{staticClass:"btn-pill pull-right",attrs:{"type":"submit","size":"md","variant":"success"}},[(!_vm.makePaymentDialog.showLoader)?_c('i',{staticClass:"fa fa-check"}):_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v(" Pay Now\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$route.name === 'Visited Sites')?_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"title":"<b>Visited Sites</b> List","sub-title":""}},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"lg":"4","md":"4"}},[_c('b-form-group',{attrs:{"label":"Period","label-for":"visitDateTime","label-cols":2,"horizontal":true}},[_c('date-picker',{attrs:{"range":"","format":"dd/MM/yyyy","lang":"en","width":"212","not-after":_vm.filterBy.DateTimeNotAfter,"placeholder":" "},model:{value:(_vm.filterBy.DateTime),callback:function ($$v) {_vm.$set(_vm.filterBy, "DateTime", $$v)},expression:"filterBy.DateTime"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"3"}},[_c('b-form-group',{attrs:{"label":"Site","label-for":"site","label-cols":2,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.filterBy.facilityList},model:{value:(_vm.filterBy.site_uuid),callback:function ($$v) {_vm.$set(_vm.filterBy, "site_uuid", $$v)},expression:"filterBy.site_uuid"}},[_c('template',{slot:"first"},[_c('option',{domProps:{"value":null}},[_vm._v("All Site")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2","md":"2"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"variant":"success"},on:{"click":function($event){_vm.doFilter()}}},[_c('i',{staticClass:"fa fa-search"})])],1)],1),_vm._v(" "),_c('c-server-table',{ref:"dataTable",attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"options":_vm.options,"method_1":_vm.setColorStatus,"method_2":_vm.doBookingApproval,"method_3":_vm.doConfirmRejecting}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(295);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7e3822c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(749);
function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7e3822c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"title":'Visited Site <b>Details</b>',"sub-title":""}},[_c('b-form-row',{staticClass:"form-detail"},[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"label":"Start Time","label-for":"startTime","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.startTime))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"End Time","label-for":"endTime","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.endTime))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Site","label-for":"site","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.site !== null && _vm.facility.site !== '' ? _vm.facility.site.name : '-'))])])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"label":"Visited By","label-for":"visitedBy","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.visitedBy))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Description","label-for":"description","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.description))])])],1),_vm._v(" "),_c('b-col',{staticClass:"top-padding-6",attrs:{"md":"12"}},[_c('b-form-group',{staticStyle:{"margin":"2rem auto 1rem"},attrs:{"label":"<h4><b>Photos</b></h4>","label-for":"actions"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{staticClass:"top-padding-6",attrs:{"label":"","label-for":"photo","label-class":"font-weight-bold"}},[_c('div',{directives:[{name:"viewer",rawName:"v-viewer"}]},[(_vm.photos.length == 0)?_c('label',{staticClass:"text-secondary top-padding-6"},[_vm._v("   No photo submitted")]):_vm._e(),_vm._v(" "),_vm._l((_vm.photos),function(p,index){return _c('b-img',{key:index,staticClass:"icon-large",attrs:{"src":p.path}})})],2)])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(296);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57fabd44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(751);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57fabd44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$route.name === 'Tickets')?_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"title":"<b>Ticket</b> List","sub-title":""}},[_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"lg":"4","md":"3"}},[_c('b-form-group',{attrs:{"label":"Period","label-for":"createdAt","label-cols":2,"horizontal":true}},[_c('date-picker',{attrs:{"range":"","format":"dd/MM/yyyy","lang":"en","width":"212","not-after":_vm.filterBy.DateTimeNotAfter,"placeholder":" "},model:{value:(_vm.filterBy.DateTime),callback:function ($$v) {_vm.$set(_vm.filterBy, "DateTime", $$v)},expression:"filterBy.DateTime"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"4","md":"3"}},[_c('b-form-group',{attrs:{"label":"Status","label-for":"taskStatus","label-cols":2,"horizontal":true}},[_c('b-form-select',{attrs:{"options":_vm.filterBy.taskStatusList},model:{value:(_vm.filterBy.task_status_uuid),callback:function ($$v) {_vm.$set(_vm.filterBy, "task_status_uuid", $$v)},expression:"filterBy.task_status_uuid"}},[_c('template',{slot:"first"},[_c('option',{domProps:{"value":null}},[_vm._v("All Status")])])],2)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2","md":"2"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"variant":"success"},on:{"click":function($event){_vm.doFilter()}}},[_c('i',{staticClass:"fa fa-search"})])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"lg":"2","md":"2"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"href":"#/tickets/create","size":"lg","variant":"success"}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('c-server-table',{ref:"dataTable",attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"options":_vm.options,"method_1":_vm.getStatusColor}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(297);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8585ccc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(753);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8585ccc2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)},"reset":_vm.setEmptyForm}},[_c('b-card',{attrs:{"title":(!_vm.isEditMode ? '<b>Add New</b>' : '<b>Edit</b>') + ' Ticket',"sub-title":""}},[_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-input',{attrs:{"id":"name","type":"text"},model:{value:(_vm.task.name.value),callback:function ($$v) {_vm.$set(_vm.task.name, "value", $$v)},expression:"task.name.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.task.name.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.task.name.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Site","label-for":"site","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('v-select',{attrs:{"label":"name","options":_vm.sites},model:{value:(_vm.task.site.tempValue),callback:function ($$v) {_vm.$set(_vm.task.site, "tempValue", $$v)},expression:"task.site.tempValue"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.task.site.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.task.site.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Assigned","label-for":"assigned","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('v-select',{attrs:{"label":"name","options":_vm.tenants},model:{value:(_vm.task.assigned.tempValue),callback:function ($$v) {_vm.$set(_vm.task.assigned, "tempValue", $$v)},expression:"task.assigned.tempValue"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.task.assigned.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.task.assigned.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Note","label-for":"note","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-textarea',{attrs:{"id":"note","rows":3,"max-rows":6},model:{value:(_vm.task.note.value),callback:function ($$v) {_vm.$set(_vm.task.note, "value", $$v)},expression:"task.note.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.task.note.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.task.note.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","href":"#/tickets","variant":"light"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"type":"reset","size":"md","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Reset\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"type":"submit","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Submit\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(298);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656d6da0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(757);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656d6da0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 755 */,
/* 756 */,
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"title":'Ticket <b>Details</b>',"sub-title":""}},[_c('b-form-row',{staticClass:"form-detail"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.name))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Site","label-for":"site","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.site !== null && _vm.task.site !== '' ? _vm.task.site.name : ''))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Created By","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.createdBy.value.name))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Assign to","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.assigned.value.name))])])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Status","label-for":"taskStatus","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_c('b-badge',{attrs:{"variant":_vm.getStatusColor(_vm.task.taskStatus)}},[_vm._v("\n              "+_vm._s(_vm.task.taskStatus)+"\n            ")])],1)]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Created Time","label-for":"createdAt","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.createdAt))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Updated Time","label-for":"updatedAt","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.task.updatedAt))])])],1),_vm._v(" "),_c('b-col',{staticClass:"top-padding-6",attrs:{"md":"12"}},[_c('b-form-group',{staticStyle:{"margin":"2rem auto 1rem"},attrs:{"label":"<h4>Visited Sites <b>Log</b></h4>","label-for":"actions"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"margin-top":"20px"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Start Time")]),_vm._v(" "),_c('th',[_vm._v("End Time")]),_vm._v(" "),_c('th',[_vm._v("Site")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Photo")])])]),_vm._v(" "),(_vm.sites.length > 0)?_c('tbody',_vm._l((_vm.sites),function(site){return _c('tr',{key:site.uuid},[_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.setDate(site.startTime)))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.setDate(site.endTime)))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(site.site.name))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('b-badge',{attrs:{"variant":site.description === 'At Site' ? 'warning' : 'primary'}},[_vm._v(_vm._s(site.description))])],1),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('div',{directives:[{name:"viewer",rawName:"v-viewer"}]},[(site.photos.length == 0)?_c('label',{staticClass:"text-secondary top-padding-6"},[_vm._v("   No photo submitted")]):_vm._e(),_vm._v(" "),_vm._l((site.photos),function(p,index){return _c('b-img',{key:index,staticClass:"icon-large img-fluid",attrs:{"fluid":"","src":p.path}})})],2)])])})):_c('tbody',[_c('tr',[_c('td',{staticClass:"text-sedcondary text-center",attrs:{"colspan":"5"}},[_vm._v("Visited Site has no data")])])])])])],1)],1),_vm._v(" "),_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f871321_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(759);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f871321_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name === 'Settings')?_c('b-card',{attrs:{"title":"<b>Settings</b>"}}):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(299);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35c0bad7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(763);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35c0bad7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-with-del-btn"},[_c('b-form-input',{attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required,"readonly":_vm.readonly,"autocomplete":_vm.autocomplete,"aria-required":_vm.ariaRequired,"aria-invalid":_vm.ariaInvalid,"type":_vm.type,"value":_vm.value},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}}),_vm._v(" "),(_vm.inputVal !== null && _vm.inputVal !== '')?_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"},on:{"click":_vm.clearVal}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$route.name === 'Administrators')?_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('h4',{staticClass:"card-title"},[_c('b',[_vm._v("Administrators")]),_vm._v(" List")]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"4","md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"visitType","label-cols":3,"horizontal":true}},[_c('text-input-del-btn',{attrs:{"id":"exampleInput2","type":"text","placeholder":""},model:{value:(_vm.filterBy.search),callback:function ($$v) {_vm.$set(_vm.filterBy, "search", $$v)},expression:"filterBy.search"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2","md":"2"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"variant":"success"},on:{"click":function($event){_vm.doFilter()}}},[_c('i',{staticClass:"fa fa-search"})])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"lg":"6","md":"4"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"href":"#/settings/user/admin/create","size":"lg","variant":"success"}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('c-server-table',{ref:"dataTable",attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"options":_vm.options,"method_1":_vm.doUpdateStatus}})],1)],1):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(302);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99bd52d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99bd52d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmitAdmin($event)}}},[_c('h4',{staticClass:"card-title"},[(!_vm.isEditMode)?_c('b',[_vm._v("Add New")]):_c('b',[_vm._v("Edit")]),_vm._v(" Administrator")]),_vm._v(" "),_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"firstName","type":"text","placeholder":"first"},model:{value:(_vm.user.firstName.value),callback:function ($$v) {_vm.$set(_vm.user.firstName, "value", $$v)},expression:"user.firstName.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.firstName.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.firstName.error))]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"lastName","type":"text","placeholder":"last"},model:{value:(_vm.user.lastName.value),callback:function ($$v) {_vm.$set(_vm.user.lastName, "value", $$v)},expression:"user.lastName.value"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","label-for":"phone","label-class":"font-weight-bold","horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"phone","type":"text"},model:{value:(_vm.user.phone.value),callback:function ($$v) {_vm.$set(_vm.user.phone, "value", $$v)},expression:"user.phone.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.phone.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.phone.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Gender","label-for":"gender","label-class":"font-weight-bold","horizontal":true}},[_c('b-form-radio-group',{attrs:{"id":"radios2"},model:{value:(_vm.user.gender.value),callback:function ($$v) {_vm.$set(_vm.user.gender, "value", $$v)},expression:"user.gender.value"}},[_c('b-form-radio',{attrs:{"value":"male"}},[_vm._v("Male")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"female"}},[_vm._v("Female")])],1),_vm._v(" "),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.gender.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.gender.error))]):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Authentication","label-for":"authentication","label-class":"font-weight-bold","horizontal":true}},[_c('b-form-group',{attrs:{"label":"email","label-for":"email","horizontal":true}},[_c('b-form-input',{attrs:{"id":"email","type":"text"},model:{value:(_vm.user.email.value),callback:function ($$v) {_vm.$set(_vm.user.email, "value", $$v)},expression:"user.email.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.email.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.email.error))]):_vm._e()],1),_vm._v(" "),(!_vm.isEditMode)?_c('b-form-group',{attrs:{"label":"password","label-for":"password","horizontal":true}},[_c('b-form-input',{attrs:{"id":"password","type":"password"},model:{value:(_vm.user.password.value),callback:function ($$v) {_vm.$set(_vm.user.password, "value", $$v)},expression:"user.password.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.email.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.password.error))]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.user.relation.value !== null)?_c('b-form-group',{attrs:{"label":"Relation","label-for":"relation","label-class":"font-weight-bold","horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-input',{attrs:{"id":"phone","type":"text","placeholder":"ex: Pal"},model:{value:(_vm.user.relation.value),callback:function ($$v) {_vm.$set(_vm.user.relation, "value", $$v)},expression:"user.relation.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.user.relation.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.user.relation.error))]):_vm._e()],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"type":"reset","size":"md","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Reset\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"type":"submit","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Submit\n            ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(303);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81281b28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(767);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81281b28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_vm._m(0,false,false),_vm._v(" "),_c('b-form-row',{staticClass:"form-detail"},[_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.user.firstName + ' ' + _vm.user.lastName))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","label-for":"phone","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.user.phone))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"email","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.user.email))])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n          ")])],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_vm._v("Administrator "),_c('b',[_vm._v("Details")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(304);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506d835f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(769);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506d835f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.$route.name === 'Contractors')?_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('h4',{staticClass:"card-title"},[_c('b',[_vm._v("Contractors")]),_vm._v(" List")]),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"lg":"4","md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"visitType","label-cols":3,"horizontal":true}},[_c('text-input-del-btn',{attrs:{"id":"exampleInput2","type":"text","placeholder":""},model:{value:(_vm.filterBy.search),callback:function ($$v) {_vm.$set(_vm.filterBy, "search", $$v)},expression:"filterBy.search"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"2","md":"2"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"variant":"success"},on:{"click":function($event){_vm.doFilter()}}},[_c('i',{staticClass:"fa fa-search"})])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"lg":"6","md":"4"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"href":"#/settings/user/contractors/create","size":"lg","variant":"success"}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('c-server-table',{ref:"dataTable",attrs:{"url":_vm.apiUrl,"urlRemove":_vm.apiUrlDelete,"columns":_vm.columns,"options":_vm.options,"method_1":_vm.openStatusReasonModal}})],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"statusReasonModal",attrs:{"hide-footer":"","title":"Reason Change Status"}},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.doUpdateStatus($event)}}},[_c('b-alert',{attrs:{"show":_vm.statusReason.hasError !== false,"variant":"danger"}},[_c('i',{staticClass:"fa fa-exclamation",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.statusReason.hasError))]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Reason","label-for":"note","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-textarea',{attrs:{"id":"textarea1","placeholder":"Reason","rows":3,"max-rows":6},model:{value:(_vm.statusReason.note),callback:function ($$v) {_vm.$set(_vm.statusReason, "note", $$v)},expression:"statusReason.note"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")])],1),_vm._v(" "),_c('b-button',{staticClass:"btn-pill pull-right",attrs:{"type":"submit","size":"md","variant":"primary"}},[(!_vm.statusReason.showLoader)?_c('i',{staticClass:"fa fa-plus"}):_c('i',{staticClass:"fa fa-spinner fa-spin fa-fw"}),_vm._v(" Submit\n      ")])],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(305);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddd766a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(772);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eddd766a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'Afghan': 'Afghanistan',
  'Argentine Argentinian': 'Argentina',
  'Australian': 'Australia',
  'Belgian': 'Belgium',
  'Bolivian': 'Bolivia',
  'Brazilian': 'Brazil',
  'Cambodian': 'Cambodia',
  'Cameroonian': 'Cameroon',
  'Canadian': 'Canada',
  'Chilean': 'Chile',
  'Chinese': 'China',
  'Colombian': 'Colombia *',
  'Costa Rican': 'Costa Rica',
  'Cuban': 'Cuba',
  'Danish (Dane)': 'Denmark',
  'Dominican': 'Dominican Republic',
  'Ecuadorian': 'Ecuador',
  'Egyptian': 'Egypt',
  'Salvadorian': 'El Salvador',
  'English': 'England',
  'Estonian': 'Estonia',
  'Ethiopian': 'Ethiopia',
  'Finnish': 'Finland',
  'French': 'France',
  'German': 'Germany',
  'Ghanaian': 'Ghana',
  'Greek': 'Greece',
  'Guatemalan': 'Guatemala',
  'Haitian': 'Haiti',
  'Honduran': 'Honduras',
  'Indonesian': 'Indonesia',
  'Iranian': 'Iran',
  'Irish': 'Ireland',
  'Israeli': 'Israel',
  'Italian': 'Italy',
  'Japanese': 'Japan',
  'Jordanian': 'Jordan',
  'Kenyan': 'Kenya',
  'Laotian': 'Laos',
  'Latvian': 'Latvia',
  'Lebanese': 'Lebanon',
  'Lithuanian': 'Lithuania',
  'Malaysian': 'Malaysia',
  'Mexican': 'Mexico',
  'Moroccan': 'Morocco',
  'Dutch': 'Netherlands',
  'New Zealander': 'New Zealand',
  'Nicaraguan': 'Nicaragua',
  'Norwegian': 'Norway',
  'Panamanian': 'Panama',
  'Paraguayan': 'Paraguay',
  'Peruvian': 'Peru',
  'Filipino': 'Philippines',
  'Polish': 'Poland',
  'Portuguese': 'Portugal',
  'Puerto Rican': 'Puerto Rico',
  'Romanian': 'Romania',
  'Russian': 'Russia',
  'Saudi': 'Saudi Arabia',
  'Scottish': 'Scotland',
  'Korean': 'South Korea',
  'Spanish': 'Spain',
  'Swedish': 'Sweden',
  'Swiss': 'Switzerland',
  'Taiwanese': 'Taiwan',
  'Tajik': 'Tajikistan',
  'Thai': 'Thailand',
  'Turkish': 'Turkey',
  'Ukrainian': 'Ukraine',
  'British': '(The) United Kingdom',
  'American **': '(The) United States',
  'Uruguayan': 'Uruguay',
  'Venezuelan': 'Venezuela',
  'Vietnamese': 'Vietnam',
  'Welsh': 'Wales'
};

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)}}},[_c('h4',{staticClass:"card-title"},[(!_vm.isEditMode)?_c('b',[_vm._v("Add New")]):_c('b',[_vm._v("Edit")]),_vm._v(" Contractor")]),_vm._v(" "),_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"firstName","type":"text","placeholder":"first"},model:{value:(_vm.tenant.firstName.value),callback:function ($$v) {_vm.$set(_vm.tenant.firstName, "value", $$v)},expression:"tenant.firstName.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.tenant.firstName.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.firstName.error))]):_vm._e()],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"lastName","type":"text","placeholder":"last"},model:{value:(_vm.tenant.lastName.value),callback:function ($$v) {_vm.$set(_vm.tenant.lastName, "value", $$v)},expression:"tenant.lastName.value"}})],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Phone","label-for":"phone","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"phone","type":"text"},model:{value:(_vm.tenant.phone.value),callback:function ($$v) {_vm.$set(_vm.tenant.phone, "value", $$v)},expression:"tenant.phone.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.tenant.phone.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.phone.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Mobile","label-for":"mobile","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"id":"mobile","type":"text"},model:{value:(_vm.tenant.mobile.value),callback:function ($$v) {_vm.$set(_vm.tenant.mobile, "value", $$v)},expression:"tenant.mobile.value"}}),_vm._v(" "),(_vm.tenant.mobile.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.mobile.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Gender","label-for":"gender","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-radio-group',{attrs:{"id":"radios2"},model:{value:(_vm.tenant.gender.value),callback:function ($$v) {_vm.$set(_vm.tenant.gender, "value", $$v)},expression:"tenant.gender.value"}},[_c('b-form-radio',{attrs:{"value":"male"}},[_vm._v("Male")]),_vm._v(" "),_c('b-form-radio',{attrs:{"value":"female"}},[_vm._v("Female")])],1),_vm._v(" "),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")])],1)],1),_vm._v(" "),(_vm.tenant.gender.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.gender.error))]):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Authentication","label-for":"authentication","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-group',{attrs:{"label":"email","label-for":"email","label-cols":3,"horizontal":true}},[_c('b-form-input',{attrs:{"id":"email","type":"text"},model:{value:(_vm.tenant.email.value),callback:function ($$v) {_vm.$set(_vm.tenant.email, "value", $$v)},expression:"tenant.email.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.tenant.email.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.email.error))]):_vm._e()],1),_vm._v(" "),(!_vm.isEditMode)?_c('b-form-group',{attrs:{"label":"password","label-for":"password","label-cols":3,"horizontal":true}},[_c('b-form-input',{attrs:{"id":"password","type":"password"},model:{value:(_vm.tenant.password.value),callback:function ($$v) {_vm.$set(_vm.tenant.password, "value", $$v)},expression:"tenant.password.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.tenant.email.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.password.error))]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.tenant.relation.value !== null)?_c('b-form-group',{attrs:{"label":"Relation","label-for":"relation","label-class":"font-weight-bold","label-cols":3,"horizontal":true}},[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-input',{attrs:{"id":"phone","type":"text","placeholder":"ex: Pal"},model:{value:(_vm.tenant.relation.value),callback:function ($$v) {_vm.$set(_vm.tenant.relation, "value", $$v)},expression:"tenant.relation.value"}}),_vm._v(" "),(_vm.tenant.relation.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.tenant.relation.error))]):_vm._e()],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"type":"reset","size":"md","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Reset\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"type":"submit","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Submit\n            ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(307);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59eef8e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(774);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59eef8e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_vm._m(0,false,false),_vm._v(" "),_c('b-form-row',{staticClass:"form-detail"},[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"First Name","label-for":"firstName","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.firstName))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"LastName","label-for":"lastName","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.lastName))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Gender","label-for":"gender","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.gender))])])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',{attrs:{"label":"Phone","label-for":"phone","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.phone))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Mobile","label-for":"mobile","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.mobile))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Email","label-for":"email","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.email))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Created Time","label-for":"createdAt","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.createdAt))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Updated Time","label-for":"updatedAt","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.tenant.updatedAt))])])],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n          ")])],1)],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-title"},[_vm._v("Contractor "),_c('b',[_vm._v("Details")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(308);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e54ae9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(776);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e54ae9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[(_vm.$route.name === 'Sites')?_c('b-card',{attrs:{"title":"<b>Site</b> List","sub-title":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"4","md":"6"}}),_vm._v(" "),_c('b-col',{attrs:{"lg":"2","md":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"lg":"6","md":"4"}},[_c('b-button',{staticClass:"btn-rounded mb-3",attrs:{"href":"#/settings/sites/create","size":"lg","variant":"success"}},[_c('i',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('c-server-table',{ref:"dataTable",attrs:{"url":_vm.apiUrl,"columns":_vm.columns,"options":_vm.options}})],1):_vm._e(),_vm._v(" "),_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(309);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07aef88a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(783);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07aef88a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 778 */,
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__(782);
function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */,
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();_vm.clearTime($event)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();_vm.toggleDropdown($event)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();_vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();_vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();_vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();_vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-form',{on:{"submit":function($event){$event.preventDefault();_vm.onSubmit($event)},"reset":_vm.setEmptyForm}},[_c('b-card',{attrs:{"title":(!_vm.isEditMode ? '<b>Add New</b>' : '<b>Edit</b>') + ' Site',"sub-title":""}},[_c('progress-loader',{ref:"progress"}),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[(_vm.errorMsg !== null)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.errorMsg)}}):_vm._e()]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-input',{attrs:{"id":"name","type":"text"},model:{value:(_vm.facility.name.value),callback:function ($$v) {_vm.$set(_vm.facility.name, "value", $$v)},expression:"facility.name.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.facility.name.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.facility.name.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Desription","label-for":"description","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-textarea',{attrs:{"id":"name","rows":3,"max-rows":6},model:{value:(_vm.facility.description.value),callback:function ($$v) {_vm.$set(_vm.facility.description, "value", $$v)},expression:"facility.description.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.facility.description.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.facility.description.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Address","label-for":"address","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-textarea',{attrs:{"id":"name","rows":3,"max-rows":6},model:{value:(_vm.facility.address.value),callback:function ($$v) {_vm.$set(_vm.facility.address, "value", $$v)},expression:"facility.address.value"}}),_c('span',{staticClass:"required-input-sign"},[_vm._v("*")]),_vm._v(" "),(_vm.facility.address.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.facility.address.error))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{directives:[{name:"show",rawName:"v-show",value:(this.isEditMode),expression:"this.isEditMode"}],attrs:{"label":"Availability","label-for":"availability","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('toggle-button',{attrs:{"color":"#3E975D","sync":true},model:{value:(_vm.facility.isAvailable.tempValue),callback:function ($$v) {_vm.$set(_vm.facility.isAvailable, "tempValue", $$v)},expression:"facility.isAvailable.tempValue"}}),_vm._v(" "),_c('b',{staticClass:"padding-top-6"},[_vm._v("Available")]),_vm._v(" "),(_vm.facility.isAvailable.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.facility.isAvailable.error))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Icon","label-for":"icon","label-class":"font-weight-bold","label-cols":"3","horizontal":true}},[_c('b-form-file',{ref:"icon",attrs:{"id":"inputIcon","state":Boolean(_vm.facility.icon.value),"placeholder":"Choose an icon...","accept":"image/jpeg, image/png, image/gif"},on:{"change":function($event){_vm.getImageURL('icon', null)}},model:{value:(_vm.facility.icon.value),callback:function ($$v) {_vm.$set(_vm.facility.icon, "value", $$v)},expression:"facility.icon.value"}}),_vm._v(" "),(_vm.facility.icon.error !== null)?_c('div',{staticClass:"invalid-feedback d-block",attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true"}},[_vm._v(_vm._s(_vm.facility.icon.error))]):_vm._e(),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"lg":"12 mt-2"}},[_c('b-img',{staticClass:"img-fluid",attrs:{"id":"icon","src":"#","fluid":"","alt":""}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","href":"#/settings/sites","variant":"light"}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n            ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"type":"reset","size":"md","variant":"danger"}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" Reset\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill",attrs:{"type":"submit","size":"md","variant":"primary"}},[_c('i',{staticClass:"fa fa-dot-circle-o"}),_vm._v(" Submit\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(312);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5feff66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(787);
function injectStyle (ssrContext) {
  __webpack_require__(785)
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5feff66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"title":'Site <b>Details</b>',"sub-title":""}},[_c('b-form-row',{staticClass:"form-detail"},[(_vm.facility.icon !== null && _vm.facility.icon !== '')?_c('b-col',{staticClass:"text-center",attrs:{"sm":"12","lg":"3"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.facility.icon,"fluid":"","alt":""}})]):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","lg":"9"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"label":"Name","label-for":"name","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.name))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Description","label-for":"description","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.description))])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Address","label-for":"address","label-class":"font-weight-bold","horizontal":true}},[_c('label',{staticClass:"top-padding-6"},[_vm._v(_vm._s(_vm.facility.address))])])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{attrs:{"label":"QR Code","label-for":"qrCode","label-class":"font-weight-bold"}},[_c('img',{staticClass:"icon-preview",attrs:{"src":_vm.facility.qrCode,"alt":""}})]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill mr-1",attrs:{"size":"md","variant":"primary","title":"Print"},on:{"click":function($event){_vm.actionToQrCode('print')}}},[_c('i',{staticClass:"fa fa-print"})]),_vm._v(" "),_c('b-button',{staticClass:"btn-pill btn-download",attrs:{"size":"md","variant":"primary","title":"Download"},on:{"click":function($event){_vm.actionToQrCode('download')}}},[_c('i',{staticClass:"fa fa-download"})])],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[_c('b-col',{staticClass:"d-md-down-none",attrs:{"md":"6","lg":"3"}},[_c('b-button',{staticClass:"btn-pill",attrs:{"size":"md","variant":"light"},on:{"click":function($event){_vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPrintQrCode),expression:"showPrintQrCode"}],attrs:{"id":"printQrCode"}},[_c('div',{staticClass:"close-button d-print-none"},[_c('i',{staticClass:"fa fa-times badge-danger",attrs:{"aria-hidden":"true"},on:{"click":_vm.closeQrCodePrinter}})]),_vm._v(" "),_c('canvas',{attrs:{"id":"qrCodeCanvas","width":"500","height":"500"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(313);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610f9ddc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(840);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_610f9ddc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  items: [{
    name: 'Dashboard',
    url: '/dashboard',
    class: 'mt-2',
    icon: 'fa fa-dashboard'
  }, {
    name: 'Ticket',
    url: '/tickets',
    icon: 'fa fa-tasks'
  }, {
    name: 'Visited Sites',
    url: '/visited-sites',
    icon: 'fa fa-building'
  }, {
    name: 'Settings',
    icon: 'fa fa-cogs',
    children: [{
      name: 'User',
      url: '/settings/user',
      icon: 'fa fa-group'
    }, {
      name: 'Sites',
      url: '/settings/sites',
      icon: 'fa fa-building'
    }]
  }]
};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = exports.Sidebar = exports.Header = exports.Footer = exports.Callout = exports.Breadcrumb = exports.Aside = undefined;

var _Aside = __webpack_require__(791);

var _Aside2 = _interopRequireDefault(_Aside);

var _Breadcrumb = __webpack_require__(316);

var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);

var _Callout = __webpack_require__(798);

var _Callout2 = _interopRequireDefault(_Callout);

var _Footer = __webpack_require__(800);

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = __webpack_require__(802);

var _Header2 = _interopRequireDefault(_Header);

var _Sidebar = __webpack_require__(813);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Switch = __webpack_require__(838);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Aside = _Aside2.default;
exports.Breadcrumb = _Breadcrumb2.default;
exports.Callout = _Callout2.default;
exports.Footer = _Footer2.default;
exports.Header = _Header2.default;
exports.Sidebar = _Sidebar2.default;
exports.Switch = _Switch2.default;

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(314);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0f2c158_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(796);
function injectStyle (ssrContext) {
  __webpack_require__(792)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0f2c158_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba82168_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(795);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ba82168"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba82168_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('div',{staticClass:"list-group list-group-accent"},[_vm._l((_vm.notificationList),function(notification){return _c('div',{key:notification.uuid,class:'list-group-item list-group-item-accent-warning list-group-item-divider notification-item' + (!notification.unread ? ' hasRead' : ''),on:{"click":function($event){_vm.readNotification(notification.uuid, notification)}}},[_c('div',[_vm._v(_vm._s(notification.title))]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-clock"}),_vm._v("  "+_vm._s(notification.createdAt))])])}),_vm._v(" "),(!_vm.lastPage && _vm.notificationList.length)?_c('div',{staticClass:"list-group-item list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small",on:{"click":function($event){$event.preventDefault();if($event.target !== $event.currentTarget){ return null; }_vm.loadMore($event)}}},[_vm._v("Load More")]):_vm._e()],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"card-header",staticStyle:{"position":"fixed","z-index":"999","width":"100%","top":"50px"},attrs:{"data-v-8a07588c":""}},[_vm._v("All "),_c('b',[_vm._v("Notifications")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('div',{staticClass:"tab-content"},[_c('notification-list')],1),_vm._v(" "),_c('button',{staticClass:"bg-white navbar-toggler aside-menu-toggler d-md-down-none m-2",attrs:{"type":"button"},on:{"click":_vm.asideToggle}},[_c('i',{staticClass:"fa fa-chevron-right"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb",staticStyle:{"border":"none","padding":"0px"}},_vm._l((_vm.list),function(item,index){return (_vm.list[index].name !== undefined)?_c('li',{key:index,staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):(_vm.isFirst(index))?_c('router-link',{staticClass:"text-muted",attrs:{"to":"/"}},[_c('span',{staticClass:"fa fa-home"})]):_c('router-link',{attrs:{"to":_vm.list[index].path}},[_vm._v(_vm._s(_vm.showName(item)))])],1):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(318);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(799);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(319);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d60a1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(801);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73d60a1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span'),_vm._v(" "),_c('span',{staticClass:"ml-auto"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(320);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b4d378_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(812);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83b4d378_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(321);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a21e9ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(804);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a21e9ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/default.png","alt":""}}),_vm._v(" "),_c('label',{staticStyle:{"margin-right":"30px"}},[_vm._v("\n      "+_vm._s(_vm.$store.getters.accountData.firstName + ' ' + _vm.$store.getters.accountData.lastName)+"\n    ")])]),_vm._v(" "),_c('b-dropdown-header',{staticClass:"text-center",attrs:{"tag":"div"}},[_c('strong',[_c('i',{staticClass:"fa fa-building-o",attrs:{"aria-hidden":"true"}}),_vm._v("  "+_vm._s(_vm.$store.getters.accountData.account.name))])]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#/profile"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Profile")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"#/logout"}},[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v(" Logout\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNotification_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce5f540_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNotification_vue__ = __webpack_require__(807);
function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ce5f540"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ce5f540_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"d-md-down-none",attrs:{"right":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-bell faa-ring",class:{ animated: _vm.isRinging },on:{"click":function($event){_vm.isRinging = false}}}),_vm._v(" "),(_vm.notificationList.length)?_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.notificationTotals))]):_vm._e()],1),_vm._v(" "),(_vm.notificationList.length)?_vm._l((_vm.notificationList),function(notification){return _c('b-dropdown-item',{key:notification.notificationUuid,staticClass:"notification-item",on:{"click":function($event){_vm.readNotification(notification.notificationUuid, notification.uuid, notification.type)}}},[_c('div',{staticClass:"text"},[_c('h4',[_vm._v(_vm._s(notification.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(notification.createdAt))])])])}):[_c('b-dropdown-item',{staticClass:"notification-item"},[_c('p',{staticClass:"mb-0"},[_vm._v("No Unread Notifications")])])],_vm._v(" "),_c('b-dropdown-item',{staticClass:"notification-item notification-footer show-all-notif",on:{"click":_vm.asideToggle}},[_c('b',[_vm._v("See All Notifications")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationBubble_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abeabb44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationBubble_vue__ = __webpack_require__(809);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationBubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abeabb44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationBubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notification-bubble"}},_vm._l((_vm.notifications),function(notification,key){return _c('div',{key:notification.id,ref:'bubble' + notification.id,refInFor:true,staticClass:"bubble bounceInRight",class:{ fadeOutRight: notification.isClose, hidden: notification.isHide },on:{"animationend":function($event){_vm.removeThis(key)}}},[_c('div',{on:{"click":function($event){_vm.readNotification(notification.notificationUuid, notification.uuid, notification.type, key)}}},[_vm._m(0,true,false),_vm._v(" "),_c('div',{staticClass:"line"}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(notification.title))]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(notification.body))])])]),_vm._v(" "),_c('div',{staticClass:"close-button",on:{"click":function($event){_vm.closeBubble(key)}}},[_c('i',{staticClass:"fa fa-times"})])])}))}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":__webpack_require__(810)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "../../static/img/iwk-icon-w33.c888629.png";

/***/ }),
/* 811 */,
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}},[_c('h2',{staticStyle:{"overflow":"hidden"}},[_c('router-link',{staticClass:"text-white",staticStyle:{"text-decoration":"none"},attrs:{"to":"/"}},[_vm._v("\n                        \n      ")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"},[_c('i',{staticClass:"fa fa-bars",staticStyle:{"color":"#3f82b6","margin-top":"6px"},attrs:{"aria-hidden":"true"}})])])],1)]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"d-md-down-none"},[_c('breadcrumb',{attrs:{"list":_vm.list}})],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdown')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(324);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fec6b372_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(837);
function injectStyle (ssrContext) {
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fec6b372_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(816);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ba21578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba3620ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(818);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba3620ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-form"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_331d77a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(820);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_331d77a1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-header"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(822);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c1719c08_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396a8720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(828);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_396a8720_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(830);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6afdaf6b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60506e66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(832);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60506e66_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(834);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547d9c6e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(836);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d60a13a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(337);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(839);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[(_vm.$store.getters.isOffline)?_c('div',[_c('b-alert',{attrs:{"variant":"danger","show":""}},[_c('b',[_vm._v("No Connection detected.")]),_vm._v(" You are offline right now, please check your internet connection.")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)]),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(338);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4a02b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(872);
function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b4a02b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230c1ca4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moduleMenu_vue__ = __webpack_require__(845);
function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230c1ca4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_moduleMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/visitor"}},[_c('i',{staticClass:"fa fa-group"}),_vm._v(" "),_c('label',[_vm._v("Visitors")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/facility-booking"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('label',[_vm._v("Book Facilities")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/complaint"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('label',[_vm._v("User Complaints")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/bcmessage"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('label',[_vm._v("Broadcast Messages")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/reports"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('label',[_vm._v("Reports")])])],1)],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"md":"2"}},[_c('b-card',{attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 pl-3"},[_c('router-link',{attrs:{"to":"/settings"}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('label',[_vm._v("Settings")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorPieChart_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339db0a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorPieChart_vue__ = __webpack_require__(847);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorPieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339db0a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorPieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.pieOptions.day === null)?_c('div',{staticClass:"text-center",staticStyle:{"font-size":"1em","padding":"100px 0px 100px"}},[_c('b-badge',[_vm._v("There's no statistics data")])],1):_vm._e(),_vm._v(" "),_c('vue-highcharts',{attrs:{"options":_vm.pieOptions.day}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorList_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99679980_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorList_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99679980_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -56px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"315px","overflow-y":"auto","overflow-x":"hidden"}},[_c('ul',{staticClass:"icons-list list"},[_vm._l((_vm.visitorList),function(visitor){return (_vm.visitorList.length > 0)?_c('li',{key:visitor.name},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(visitor.name))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(visitor.vehicleType)+" "+_vm._s(visitor.vehicleColor)+" "+_vm._s(visitor.vehiclePlateNumber))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"value"},[_c('b-badge',{attrs:{"variant":_vm.getVisitorStatusColor(visitor.visitorStatus)}},[_vm._v(_vm._s(visitor.visitorStatus))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(_vm._s(visitor.visitorType)+" of "),_c('router-link',{attrs:{"to":'/settings/user/tenant/' + visitor.requestedBy.uuid + '?redirect=%2Fdashboard'}},[_vm._v(_vm._s(visitor.requestedBy.name))])],1)],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/visitor/' + visitor.uuid + '?redirect=%2Fdashboard',"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.visitorList.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('b-badge',[_vm._v("There's no visitor today")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"size":"sm","href":"#/visitor","variant":"link"}},[_c('i',{staticClass:"icon-options"})])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorLog_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb5519f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorLog_vue__ = __webpack_require__(853);
function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb5519f4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -45px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"320px","max-height":"735px","overflow-y":"auto","overflow-x":"hidden"}},[_c('ul',{staticClass:"icons-list visitor"},[_vm._m(0,false,false),_vm._v(" "),_vm._l((_vm.visitorStatusLog),function(visitor){return (_vm.visitorStatusLog.length > 0)?_c('li',{key:visitor.name},[_c('i',{class:_vm.setVisitorStatusColor(visitor.visitorStatus)}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(visitor.visitor.name))]),_vm._v(" "),_c('small',[_c('b',[_vm._v(_vm._s(visitor.visitorStatus))]),_vm._v(" at "+_vm._s(visitor.createdAt))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/visitor/' + visitor.visitor.uuid + '?redirect=%2Fdashboard',"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.visitorStatusLog.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('h5',{staticClass:"text-muted"},[_vm._v("Can't load data for a while")])]):_vm._e()],2)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticStyle:{"height":"20px"}},[_c('small',[_c('em',[_vm._v("Last 30 log of visitors")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorExceeded_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e98bd44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorExceeded_vue__ = __webpack_require__(856);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visitorExceeded_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e98bd44_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visitorExceeded_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -45px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"320px","overflow-y":"auto","overflow-x":"hidden"}},[_c('ul',{staticClass:"icons-list visitor"},[_vm._l((_vm.visitorExceeded),function(visitor){return (_vm.visitorExceeded.length > 0)?_c('li',{key:visitor.name},[_c('i',{staticClass:"icon-clock bg-danger btn-pill"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(visitor.name))]),_vm._v(" "),_c('small',[_c('b',[_vm._v(_vm._s(visitor.visitorStatus))]),_vm._v(" at "+_vm._s(visitor.visitStartTime))])]),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/visitor/' + visitor.uuid + '?redirect=%2Fdashboard',"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.visitorExceeded.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('h5',{staticClass:"text-muted"},[_vm._v("Can't load data for a while")])]):_vm._e()],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookingList_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081e24b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bookingList_vue__ = __webpack_require__(859);
function injectStyle (ssrContext) {
  __webpack_require__(858)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bookingList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_081e24b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bookingList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -56px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"315px","overflow-y":"auto","overflow-x":"hidden"}},[_c('ul',{staticClass:"icons-list list"},[_vm._l((_vm.facilityBookingList),function(facilityBooking){return (_vm.facilityBookingList.length > 0)?_c('li',{key:facilityBooking.place},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(facilityBooking.site.name))]),_vm._v(" "),_c('small',{staticClass:"text-ellipsis",domProps:{"innerHTML":_vm._s(_vm.getTimeDesc(facilityBooking))}}),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"value"},[_c('b-badge',{attrs:{"variant":"light"}},[_vm._v(_vm._s(facilityBooking.description))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v("Visited By "+_vm._s(facilityBooking.visitedBy))])],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/visited-sites/' + facilityBooking.uuid + '?redirect=%2Fdashboard',"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.facilityBookingList.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('b-badge',[_vm._v("There's no Visited Sites today")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"size":"sm","href":"#/visited-sites","variant":"link"}},[_c('i',{staticClass:"icon-options"})])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintPieChartByStatus_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eefdea86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintPieChartByStatus_vue__ = __webpack_require__(861);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintPieChartByStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eefdea86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintPieChartByStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.pieOptions == null)?_c('div',{staticClass:"text-center",staticStyle:{"font-size":"1em","padding":"100px 0px 100px"}},[_c('b-badge',[_vm._v("There's no statistics data")])],1):_c('vue-highcharts',{attrs:{"options":_vm.pieOptions}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintPieChartByCategory_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ee9f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintPieChartByCategory_vue__ = __webpack_require__(863);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintPieChartByCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67ee9f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintPieChartByCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.pieOptions == null)?_c('div',{staticClass:"text-center",staticStyle:{"font-size":"1em","padding":"100px 0px 100px"}},[_c('b-badge',[_vm._v("There's no statistics data")])],1):_c('vue-highcharts',{attrs:{"options":_vm.pieOptions}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintList_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a2b1f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintList_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_complaintList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91a2b1f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_complaintList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -56px"}}),_vm._v(" "),_c('div',{staticStyle:{"height":"315px","overflow-y":"auto","overflow-x":"hidden"}},[_c('ul',{staticClass:"icons-list list"},[_vm._l((_vm.complaintList),function(complaint){return (_vm.complaintList.length > 0)?_c('li',{key:complaint.place},[_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(complaint.place))]),_vm._v(" "),_c('small',{staticClass:"text-ellipsis"},[_vm._v(_vm._s(complaint.description))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"value"},[_c('b-badge',{attrs:{"variant":_vm.getComplaintStatusColor(complaint.complainStatus)}},[_vm._v(_vm._s(complaint.complainStatus))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-badge',{attrs:{"variant":"light"}},[_vm._v("Submitted By "),_c('router-link',{attrs:{"to":'/settings/user/tenant/' + complaint.userProfile.uuid + '?redirect=%2Fdashboard'}},[_vm._v(_vm._s(complaint.userProfile.firstName)+" "+_vm._s(complaint.userProfile.lastName))])],1)],1),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/complaint/' + complaint.uuid + '?redirect=%2Fdashboard',"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.complaintList.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('b-badge',[_vm._v("There's no complaint today")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"size":"sm","href":"#/complaint","variant":"link"}},[_c('i',{staticClass:"icon-options"})])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bcmessageList_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a61a05ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bcmessageList_vue__ = __webpack_require__(869);
function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bcmessageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a61a05ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bcmessageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h5',{staticClass:"card-header text-left"},[_vm._v("Broadcast "),_c('b',[_vm._v("Messages")]),_vm._v(" :")]),_vm._v(" "),_c('progress-loader',{ref:"progress",attrs:{"customClass":"pull-right","customStyle":"width:100px; margin-top: -56px"}}),_vm._v(" "),_c('div',{staticStyle:{"max-height":"753px","margin-top":"20px","overflow-x":"hidden","overflow-y":"auto"}},[_c('ul',{staticClass:"icons-list list"},[_vm._l((_vm.tableItems),function(t){return (_vm.tableItems.length > 0)?_c('li',{key:t.title},[_c('div',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(t.title))]),_vm._v(" "),_c('small',{domProps:{"innerHTML":_vm._s(_vm.statusMessage(t))}}),_vm._v(" "),_c('hr',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('div',{staticClass:"actions"},[_c('b-button',{staticClass:"text-muted",attrs:{"href":'#/bcmessage/' + t.uuid,"variant":"link"}},[_c('i',{staticClass:"icon-list"})])],1)]):_vm._e()}),_vm._v(" "),(_vm.tableItems.length == 0)?_c('li',{staticClass:"text-center",staticStyle:{"padding":"100px 0px"}},[_c('b-badge',[_vm._v("There's no t today")])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider text-center"},[_c('b-button',{staticClass:"text-muted",attrs:{"size":"sm","href":"#/bcmessage","variant":"link","title":"More"}},[_c('i',{staticClass:"icon-options"})])],1)],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panicPieChart_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_690767f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panicPieChart_vue__ = __webpack_require__(871);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_panicPieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_690767f7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_panicPieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.pieOptions.day === null)?_c('div',{staticClass:"text-center",staticStyle:{"font-size":"1em","padding":"100px 0px 100px"}},[_c('b-badge',[_vm._v("There's no statistics data")])],1):_vm._e(),_vm._v(" "),_c('vue-highcharts',{attrs:{"options":_vm.pieOptions.day}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"dashboard-page"}},[_c('b-row',[_c('b-col',{attrs:{"id":"charts","md":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{staticClass:"card-theme-primary d-flex flex-grow"},[_c('h5',{staticClass:"card-header text-left"},[_vm._v("Tickets "),_c('b',[_vm._v("Today")])]),_vm._v(" "),_c('visitor-pie-chart')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{staticClass:"card-theme-primary d-flex flex-grow"},[_c('h5',{staticClass:"card-header text-left"},[_vm._v("Tickets "),_c('b',[_vm._v("This Month")])]),_vm._v(" "),_c('visitor-pie-chart')],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{staticClass:"card-theme-primary d-flex flex-grow"},[_c('h5',{staticClass:"card-header text-left"},[_c('b',[_vm._v("Visited Sites")]),_vm._v(" Today")]),_vm._v(" "),_c('panic-pie-chart')],1)],1)],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"card-theme-primary"},[_c('h5',{staticClass:"card-header text-left"},[_vm._v("Visited Sites for "),_c('b',[_vm._v("Today")])]),_vm._v(" "),_c('booking-list',{staticClass:"mt-2"})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__ = __webpack_require__(350);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f6422f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__ = __webpack_require__(874);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f6422f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("404")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! You're lost.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The page you are looking for was not found.")])]),_vm._v(" "),_c('div',{staticClass:"text-center"})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__ = __webpack_require__(351);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713a7ebc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__ = __webpack_require__(876);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page500_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_713a7ebc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page500_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"6"}},[_c('div',{staticClass:"clearfix"},[_c('h1',{staticClass:"float-left display-3 mr-4"},[_vm._v("500")]),_vm._v(" "),_c('h4',{staticClass:"pt-3"},[_vm._v("Oops! Internal Error.")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Please contact your administrator for more information.")])]),_vm._v(" "),_c('div',{staticClass:"text-center"})])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(352);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263beb02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(878);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263beb02_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-nav',{staticClass:"mb-2",attrs:{"pills":""}},[_c('b-nav-item',{staticClass:"btn-pill",attrs:{"href":"#/settings/user/contractors","active":_vm.linkActive('contractors')}},[_vm._v(" Contractor")]),_vm._v(" "),_c('b-nav-item',{staticClass:"btn-pill",attrs:{"href":"#/settings/user/admin","active":_vm.linkActive('admin')}},[_vm._v("Administrator")])],1),_vm._v(" "),_c('hr',{staticClass:"mb-4"}),_vm._v(" "),_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(9);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(880);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(311);

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__(17);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(891);

var _vuex2 = _interopRequireDefault(_vuex);

var _axios = __webpack_require__(5);

var _axios2 = _interopRequireDefault(_axios);

var _router = __webpack_require__(133);

var _router2 = _interopRequireDefault(_router);

var _app = __webpack_require__(357);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(892);

var _momentTimezone = __webpack_require__(893);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: {
    accessToken: localStorage.getItem('access_token'),
    refreshToken: localStorage.getItem('refresh_token'),
    accountData: localStorage.getItem('account_data'),
    chosenModule: localStorage.getItem('chosen_module'),
    isOffline: false,
    firebaseMessaging: null
  },
  mutations: {
    changeChosenModule: function changeChosenModule(state, chosenModule) {
      localStorage.setItem('chosen_module', chosenModule);
      _vue2.default.set(state, 'chosenModule', chosenModule);
    },
    login: function login(state, tokens) {
      state.accessToken = tokens.access_token;
      state.refreshToken = tokens.refresh_token;
      if (!tokens.account_data !== null) {
        state.accountData = tokens.account_data;
      }
    },
    logout: function logout(state) {
      state.toggled = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.accountData = null;
    },
    checkIsOffline: function checkIsOffline(state, status) {
      state.isOffline = status;
    }
  },
  actions: {
    doChooseModule: function doChooseModule(_ref, chosenModule) {
      var commit = _ref.commit;

      commit('changeChosenModule', chosenModule);
    },
    login: function login(_ref2, credentials) {
      var state = _ref2.state,
          commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootState = _ref2.rootState;

      return _axios2.default.post(window.AppConfig.baseApiUrl + 'oauth', {
        username: credentials.username,
        password: credentials.password,
        grant_type: 'password',
        client_id: window.AppConfig.clientId,
        client_secret: window.AppConfig.clientSecret
      }).then(function (response) {
        var a = response.data;
        return dispatch('getAccountData', a.access_token).then(function (response) {
          return dispatch('saveTokens', { tokens: a, accountData: (0, _stringify2.default)(response), isLocalLogin: false });
        }).catch(function (error) {
          return _promise2.default.reject(error);
        });
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },
    getAccountData: function getAccountData(_ref3, accessToken) {
      var state = _ref3.state,
          commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      return _axios2.default.get(window.AppConfig.baseApiUrl + 'api/me', { headers: { Authorization: 'Bearer ' + accessToken } }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },
    updateAccountDataBillingConfigs: function updateAccountDataBillingConfigs(_ref4) {
      var dispatch = _ref4.dispatch,
          state = _ref4.state;

      return _axios2.default.get(window.AppConfig.apiUrl + 'billing-receipt?limit=2&ascending=1&order=order').then(function (response) {
        return dispatch('updateAccountData', { key: 'billingConfigs', value: response.data._embedded.billingReceipt });
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },
    refreshToken: function refreshToken(_ref5) {
      var state = _ref5.state,
          commit = _ref5.commit,
          rootState = _ref5.rootState;

      return _axios2.default.post(window.AppConfig.baseApiUrl + 'oauth', {
        grant_type: 'refresh_token',
        client_id: window.AppConfig.clientId,
        client_secret: window.AppConfig.clientSecret,
        refresh_token: state.refreshToken
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        return _promise2.default.reject(error);
      });
    },
    localLogin: function localLogin() {
      return {
        data: {
          access_token: localStorage.getItem('access_token'),
          refresh_token: localStorage.getItem('refresh_token')
        }
      };
    },
    logout: function logout(_ref6) {
      var commit = _ref6.commit,
          state = _ref6.state,
          dispatch = _ref6.dispatch;

      dispatch('clearFirebase');
      localStorage.removeItem('account_data');
      return _axios2.default.post(window.AppConfig.baseApiUrl + 'oauth/revoke', {
        token_type_hint: 'access_token',
        token: state.accessToken
      }).then(function () {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        commit('logout');
      }).catch(function () {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        commit('logout');
      });
    },
    initFirebase: function initFirebase(_ref7) {
      var state = _ref7.state;

      if ('serviceWorker' in navigator) {
        if (!_app2.default.apps.length) {
          _app2.default.initializeApp(window.AppConfig.fbase.initializeConfig);
          state.firebaseMessaging = _app2.default.messaging();
          state.firebaseMessaging.usePublicVapidKey(window.AppConfig.fbase.vapidKey);

          navigator.serviceWorker.register('./static/js/firebase-messaging-sw.js?baseUrl=' + window.location.origin).then(function (registration) {
            state.firebaseMessaging.useServiceWorker(registration);
            state.firebaseMessaging.requestPermission().then(function () {
              state.firebaseMessaging.getToken().then(function (currentToken) {
                if (currentToken) {
                  return _axios2.default.post(window.AppConfig.apiUrl + 'mobilestate', {
                    firebaseId: currentToken
                  }).then(function () {}).catch(function () {
                    window.consoleLog('cannot save notif token');
                  });
                }
              });
            }).catch(function () {
              alert('Please Allow Notification Permission');
            });
          });
        } else {
          state.firebaseMessaging.requestPermission().then(function () {
            state.firebaseMessaging.getToken().then(function (currentToken) {
              if (currentToken) {
                return _axios2.default.post(window.AppConfig.apiUrl + 'mobilestate', {
                  firebaseId: currentToken
                }).then(function () {}).catch(function () {
                  window.consoleLog('cannot save notif token');
                });
              }
            });
          });
        }
        state.firebaseMessaging.onTokenRefresh(function () {
          state.firebaseMessaging.getToken().then(function (refreshedToken) {
            return _axios2.default.post(window.AppConfig.apiUrl + 'mobilestate', {
              firebaseId: refreshedToken
            }).then(function () {}).catch(function () {
              window.consoleLog('cannot save notif token');
            });
          });
        });
      } else {}
    },
    clearFirebase: function clearFirebase(_ref8) {
      var state = _ref8.state;

      if ('serviceWorker' in navigator && state.firebaseMessaging !== null) {
        state.firebaseMessaging.getToken().then(function (currentToken) {
          if (currentToken) {
            state.firebaseMessaging.deleteToken(currentToken);
          }
        });
      }
    },
    updateAccountData: function updateAccountData(_ref9, params) {
      var state = _ref9.state;

      var accountData = JSON.parse(state.accountData);
      accountData[params.key] = params.value;
      localStorage.setItem('account_data', (0, _stringify2.default)(accountData));
      state.accountData = (0, _stringify2.default)(accountData);
    },
    saveTokens: function saveTokens(_ref10, params) {
      var state = _ref10.state,
          commit = _ref10.commit,
          getters = _ref10.getters,
          dispatch = _ref10.dispatch;

      var a = params.tokens.access_token;
      var b = params.tokens.refresh_token;
      var c = params.accountData === null ? state.accountData : params.accountData;
      if (!params.isLocalLogin) {
        localStorage.setItem('access_token', a);
        localStorage.setItem('refresh_token', b);
        localStorage.setItem('account_data', c);
      }
      commit('login', {
        access_token: a,
        refresh_token: b,
        account_data: c
      });

      _momentTimezone2.default.tz.setDefault(getters.accountData.timezone);
      _axios2.default.interceptors.request.use(function (config) {
        dispatch('setIsOffline', false);
        if (state.accessToken !== null) {
          config.headers.Authorization = 'Bearer ' + state.accessToken;
        }
        return config;
      });
      dispatch('initFirebase');
      if (!params.isLocalLogin) {
        dispatch('updateAccountDataBillingConfigs');
      }
      return _axios2.default.interceptors.response.use(undefined, function (err) {
        if (err.response === undefined) {
          if (err.message === 'Network Error') dispatch('setIsOffline', true);
        } else {
          dispatch('setIsOffline', false);
          if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
            return new _promise2.default(function (resolve, reject) {
              return dispatch('refreshToken').then(function (response) {
                localStorage.setItem('access_token', response.access_token);
                localStorage.setItem('refresh_token', response.refresh_token);
                commit('login', {
                  access_token: response.access_token,
                  refresh_token: response.refresh_token,
                  account_data: state.accountData
                });
                err.config.__isRetryRequest = true;

                (0, _axios2.default)(err.config).then(resolve, reject);
              }).catch(function (error) {
                return _promise2.default.reject(error);
              });
            });
          } else if (err.response.status === 400) {
            _router2.default.push('');
          } else {
            return _promise2.default.reject(err);
          }
        }
      });
    },

    setIsOffline: function setIsOffline(_ref11, status) {
      var commit = _ref11.commit;
      return commit('checkIsOffline', status);
    },
    errorMessage: function errorMessage(_ref12, error) {
      var commit = _ref12.commit;

      window.consoleLog(error);
      var messages = 'Sorry for the inconvenience.<br/>';
      if (typeof error.response !== 'undefined') {
        var validationMessages = null;
        var subValidationMessages = null;
        if (error.response.data.validation_messages !== undefined) {
          validationMessages = error.response.data.validation_messages;
          if (validationMessages !== undefined) {
            if ((0, _keys2.default)(validationMessages).length) {
              messages += '<ul>';
              for (var i = 0; i < (0, _keys2.default)(validationMessages).length; i++) {
                subValidationMessages = validationMessages[(0, _keys2.default)(validationMessages)[i]];
                for (var j = 0; j < (0, _keys2.default)(subValidationMessages).length; j++) {
                  messages += '<li>' + subValidationMessages[(0, _keys2.default)(subValidationMessages)[j]] + '</li>';
                }
              }
              messages += '</ul>';
            }
          }
        } else if (error.response.data.message !== undefined) {
          messages += error.response.data.message + '. ';
        } else if (error.response.data.detail !== undefined) {
          messages += error.response.data.detail + '. ';
        } else {
          messages += error.response.data.status + '. ' + window.ConvertSnakeCaseMesssage(error.response.data.title);
        }
      } else if (error.message === 'Network Error') {
        messages = '<b>You are not connected to internet</b>. Please check your connection';
      } else {
        messages += 'Please call Administrator to get advance information';
      }
      return messages;
    }
  },
  getters: {
    accessTokenHeader: function accessTokenHeader(state) {
      return 'Bearer ' + state.accessToken;
    },
    accessTokens: function accessTokens(state) {
      return {
        access_token: state.accessToken,
        refresh_token: state.refreshToken
      };
    },
    accountData: function accountData(state) {
      return JSON.parse(state.accountData);
    },
    getChosenModule: function getChosenModule(state) {
      return state.chosenModule;
    },
    isLoggedIn: function isLoggedIn(state) {
      return state.accessToken;
    },
    isOffline: function isOffline(state) {
      return state.isOffline;
    }
  }
});

/***/ }),
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _init = __webpack_require__(900);

var _init2 = _interopRequireDefault(_init);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.AppConfig = {
  subDomain: _init2.default.subDomain,
  baseApiUrl: 'https://resi.genietree.biz/',
  apiUrl: 'https://resi.genietree.biz/api/v1/',
  webSocketUrl: 'wss://resi.genietree.biz/ws',
  clientId: 'rcs-web',
  clientSecret: 'cb67d4ae3',
  googleApiKey: 'AIzaSyAjf3x7e9tSqU9dMHjki76zLI1UBX4Df9E',
  fbase: {
    initializeConfig: {
      apiKey: 'AIzaSyBURxWdjw2MGY7fm3QY83P9jJmiluUBXbU',
      authDomain: 'ics-prod-222416.firebaseapp.com',
      databaseURL: 'https://ics-prod-222416.firebaseio.com',
      projectId: 'ics-prod-222416',
      storageBucket: 'ics-prod-222416.appspot.com',
      messagingSenderId: '437592383519'
    },
    vapidKey: 'BECl7ojYyzdJz7LcKHzKGZ4hk_S9mf2PJ7foiTZdysAgcLwzCDnUi9wWJ6zbSNsNvo0KelNyQ6f_ELyhSSH6JcU'
  },
  IntervalRefreshData: 120000,
  IntervalRefreshDataDashboard: 300000,
  dateFormat: 'DD-MM-YYYY, hh:mm:ss A',
  shortDateFormat: 'DD-MM-YYYY'
};

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var subDomain = 'dev';
var Init = function Init() {
  return {
    subDomain: subDomain
  };
};
exports.default = new Init();

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(154);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(9);

var _keys2 = _interopRequireDefault(_keys);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.setDefaultNull = function (value, value2) {
  if (typeof value !== 'undefined' && value !== '' && value !== null) return value;else if (value2 !== undefined) return value2;else return null;
};

window.consoleLog = function (value) {
  if (false) {
    return console.log(value);
  }
};

window.setUrlParams = function (arrParams) {
  var urlQuery = {};
  (0, _keys2.default)(arrParams).map(function (param) {
    if (param !== 'byColumn' && arrParams[param] !== null && arrParams[param] !== '') {
      if (param === 'orderBy') {
        urlQuery['order'] = arrParams[param];
      } else {
        urlQuery[param] = arrParams[param];
      }
    }
  });

  if (!urlQuery.hasOwnProperty('order')) delete urlQuery['ascending'];
  return urlQuery;
};

window.setDetailValue = function (model, data) {
  var keys = (0, _keys2.default)(data);
  for (var i = 0; i < keys.length; i++) {
    if (model[keys[i]] === undefined) continue;
    if ((0, _typeof3.default)(model[keys[i]]) === 'object' && model[keys[i]] !== null) {
      if (data[keys[i]] !== null) {
        model[keys[i]].value = window.setDefaultNull(data[keys[i]], '');
      }
    } else {
      if (keys[i].indexOf('Date') !== -1 || keys[i].indexOf('StartTime') !== -1 || keys[i].indexOf('EndTime') !== -1 || keys[i].indexOf('edAt') !== -1) {
        model[keys[i]] = data[keys[i]] == null ? '-' : (0, _moment2.default)(data[keys[i]]).format(window.AppConfig.dateFormat);
      } else if (keys[i].indexOf('dob') !== -1) {
        model[keys[i]] = data[keys[i]] == null ? '-' : (0, _moment2.default)(data[keys[i]]).format(window.AppConfig.shortDateFormat);
      } else {
        model[keys[i]] = window.setDefaultNull(data[keys[i]], '-');
      }
    }
  }
};

window.setEmptyForm = function (model) {
  var keys = (0, _keys2.default)(model);
  for (var i = 0; i < keys.length; i++) {
    model[keys[i]].value = null;
  }
};

window.goBack = function (self) {
  if (self.$route.query.redirect !== undefined) {
    self.$router.push(self.$route.query.redirect);
  } else {
    window.history.back();
  }
};

window.ConvertSnakeCaseMesssage = function (str) {
  if (str === null || str === '') return false;else str = str.toString();

  return str.replace('_', ' ').replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

/***/ })
],[360]);


// WEBPACK FOOTER //
// static/js/app.ab012901c3cba4c746dd.js